

























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwStatusFlag } from '@libs-uuif/shared/sw-status-flag';
/* importing all the components needed in the page */
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SwBlockingProgress } from '@libs-uuif/shared/sw-blocking-progress';
import { SwContentToolbar } from '@libs-uuif/shared/sw-content-toolbar';
import { SwExpandableTextfield , SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwActionBar, SwActionBarItem } from '@libs-uuif/shared/sw-action-bar';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import {
  SwMessageContainer,
} from '@libs-uuif/shared/message-service';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { currentUserKey, isSafari } from '../../shared/msw-constants';
import * as decode from 'jwt-decode';
import CSCWCMDialog from './components/CSCWCMDialog.vue';
import { envCongif } from '@/shared/env.config';
import { DropdownLight } from '../../shared/dropdown-light';
import jsEncrypt from '../../shared/jsEncrypt';
import { SwScrollView } from '@sonicwall/unified-ui-framework/src/shared/sw-scroll-view';
import idb, { CSC_STORE_NAME } from '@/services/indexedDb.service';
import { SwStatusInfo } from '@sonicwall/unified-ui-framework/src/shared/sw-status-info';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import {  InfoState } from '@/core/core.store';
import ImageUpload from './components/image-upload.vue';
import Csc2Vdo from './components/csc2-vdo.vue';
// import { envConfigEntriesDev } from '@/shared/env-config-dictionary';
import { State } from 'vuex-class';
import { RootStoreState } from '@/store';
import { ConfirmButton, ConfirmOptions, confirmService } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import { SwDropMenu } from '@sonicwall/unified-ui-framework/src/shared/sw-drop-menu';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { Base64 } from 'js-base64';
import { PopoverDirValues } from '@sonicwall/unified-ui-framework/src/shared/popover-dir';
import { popover } from '@libs-uuif/shared/popover-dir';
import { CreateElement, VNode } from 'vue';
import { localStorageKeeperService } from '@/shared/auth-service';
declare var gtag: Function;

const cssPrefix = 'spog-homepage';
const spogSrcPath = isSafari ? '/muir/spog/login' : '/workspace/m/feature/spog-homepage';

@Component({
  components: {
    SwButton,
    SwBlockingProgress,
    SwSelect,
    SwTextfield,
    SwContentToolbar,
    DropdownLight,
    SwExpandableTextfield,
    SwActionBar,
    SwActionBarItem,
    SwMessageContainer,
    SwIconButton,
    CSCWCMDialog,
    SwScrollView,
    SwIcon,
    SwStatusFlag,
    SwStatusInfo,
    SwCheckbox,
    ImageUpload,
    SwDropMenu,
    Csc2Vdo,
  }, directives: {
    tooltip,
    popover,
  },
})
export default class SpogHomepage extends SwExtendedVue {
  @State((state: RootStoreState) => state.idleVue.isIdle)
  isIdle : boolean;
  visible:boolean;
  selTenant : string = '';
  selectedSerialNumer: string;
  cssPrefix = cssPrefix;
  searchText : any = '';
  showTenantDropDown : boolean = false;
  showInputBox : boolean = false;
  tenantList:any[] = [];
  filteredTenants: any;
  showContainer : boolean = false;
  isdemouser : boolean = false;
  capturecloudhelpurl:string = 'https://www.sonicwall.com/support/technical-documentation/docs/capture_security_center-user_guide/Content/administration_guide.htm/';
  imageHoverstring : string = '';
  token : any;
  bispoguser : boolean = false;
  mode:string = '';
  isdemo : boolean = false;
  demoTile :string = '';
  spogreturn: string = '';
  embedView : boolean = false;
  requestedTenant : any;
  activeTenantId: string;
  activeTenantEncName:string;
  activeTenantName: string = '';
  activeServices : any[] = [];
  activeService = '';
  cgmsurl: string = '';
  cgmsser: string = '';
  analyticsurl: string = '';
  analyticsser : string = '';
  casburl: string = '';
  cloudemailurl:string = '';
  cloudemailsecurityurl: string = '';
  caasurl:string = '';
  smaurl:string = '';
  ngmgmturl:string = '';
  cas2url:string = '';
  saseurl:string = '';
  tseUrl: string = '';
  tseMDRUrl: string = '';
  wafurl:string = '';
  cseUrl: string = '';
  wirelessurl:string = '';
  wifiplannerurl:string = '';
  cgmsArrTenants : any;
  cgmsClose : any;
  cgmsServiceAvailable : any;
  cgmsService : any;
  cgmsMode : any;
  showFirewallDialog : boolean = false;
  showImageUpload : boolean = false;
  profileorlogout: SelectOption[] = [];
  showSSC: boolean = false;
  value: string = 'profile';
  displayShortName : string  = '';
  seccenterurlinit:string = 'https://securitycenter.sonicwall.com/?__vm__=embedded';
  // seccenteradminurlinit:string = 'https://www.mysonicwall.com/riskmeterredirect.aspx?__vm__=embedded';
  seccenteradminurlinit:string = 'https://securitycenter.sonicwall.com?__vm__=embedded';
  seccenttersimurlinit:string = 'https://securitycenterbeta.sonicwall.com/m/page/bill-meter?__vm__=embedded&allow=fullscreen';
  // seccentersimadminurlinit:string = 'https://beta.mysonicwall.com/riskmeterredirect.aspx?__vm__=embedded';
  seccentersimadminurlinit:string = 'https://securitycenterps.sonicwall.com?__vm__=embedded';
  seccentterdevurlinit:string = 'http://10.50.15.82:8080/m/page/bill-meter?__vm__=embedded&allow=fullscreen';
  seccenterdevadminurlinit:string = 'https://10.202.8.44/riskmeterredirect.aspx?__vm__=embedded';
  seccenterurl:string = 'https://securitycenter.sonicwall.com/?__vm__=embedded';
  selection: string = 'cloud';
  isreadonlyuser : boolean = false;
  isriskmeterbeta : boolean = false;
  showNewTag :boolean = false;
  showWarnToolTip : boolean[] = [];
  showHoverOverMessage : boolean[] = [];
  showToolTip : boolean[] = [];
  nonclickableCheck : boolean = false;
  showPopUp : boolean = false;
  showCheckBoxPopup :boolean = false;
  serviceSelected : any;
  nsm2 : any[] = [];
  showInputBoxPopup : boolean = false;
  searchDeviceText : string = '';
  tempSearch : string[] = [];
  respContent: any;
  nsmServiceLength1 = 0;
  nsmServiceLength2 = 0;
  username: any;
  email : any;
  showNsmSliderAfterPopUp :boolean = true;
  imageUploadTenantId = '';
  licensemysonicwall = [
    {
      serviceName: 'LICENSES',
      serviceNameDisp: 'Licensing',
      isEnabled: true,
      avaiableRatio : '',
      imageIcon : 'Licensing.svg',
    },
    {
      serviceName: 'MYSONICWALL',
      serviceNameDisp: 'mySonicWall',
      isEnabled: true,
      avaiableRatio: '',
      imageIcon: 'MySonicWall.svg',
    },
  ];
  showProfileDD :boolean = false;
  nsmNewUrl : boolean = false;
  nsmOldUrlSelected : boolean = false;
  workOnEventListener :boolean = true;
  showVdoPopUp :boolean = false;
  selectInNSMSlider = 0;
  wrongInputInTileClick : boolean = false;
  serNumberTileClick : any;
  isInsightsEnbled : boolean = false;
  showUnifiedInsightEnabled : boolean = false;
  arrTenantOptions :  any;
  csc2Msg = this.$t('spog.homepage.cscMsg')
  .toString();
  csc2Vdo = 'https://www.mysonicwall.com/images/csc-20-preview.mp4';
  wnmMsg = this.$t('spog.homepage.wnmMsg')
  .toString();
  wnmVdo = '';
  showWNMVdoPopup : boolean = false;
  wnmRedirectUrlAfterVdo : string = '';
  accessCode : string = 'error';
  showUnifiedInsightPopup : boolean = false;
  appVersion : string = '';
  ptions: ConfirmOptions;
  buttons: ConfirmButton[];
  showExpirationWarning : boolean = false;
  navigateReportUrl: string = '';
  isSpogReportsUser: boolean = false;
  currentUserRoles: any = [];
  // MSSP Users
  selectedMssp: string = 'defaultId';
  iconColor: string = '#fff';
  msspMenuOpened: boolean = false;
  arrayMsspLists: SelectOption[] = [];
  flagstatus: any = '';
  showMSWApps: boolean = false;
  allApplicationList: any[] = [];
  showAppTrayBypClid:string = '';
  forcedReloadwhenTileClickDone: Boolean = false;
  showSPRedirectBtn: boolean = false;
  spSyncpartial: boolean = false;
  @Watch('searchText')
  @Watch('selectedMssp')
  filterTenants() {
    this.filteredTenants = this.tenantList.filter((each : any) => {
      return each.name.toLowerCase()
        .indexOf(this.searchText
        .toLowerCase()) > -1 &&
        this.isMSSPCheck(each.masterMSSPId);
    });
  }
  @Watch('searchDeviceText')
  filterNSMDevices() {
    console.warn(this.searchDeviceText);
    this.nsm2 = this.serviceSelected[0].migrateList.filter((each : any) => each.serialNumber.toLowerCase()
    .indexOf(this.searchDeviceText.toLowerCase()) > -1 || each.friendlyName.toLowerCase()
    .indexOf(this.searchDeviceText.toLowerCase()) > -1);
    console.warn(this.nsm2);
  }
  @Watch('showTenantDropDown')
  resetSearch() {
    this.searchText = '';
    this.selectedMssp = 'defaultId';
    if (this.showTenantDropDown) {
      this.toggleSearchBox(true);
    }
  }
  @Watch('activeTenantName')
  tenantChanged() {
    this.getShowUnifiedInsightFlag();
  }
  onClickBasicButton() {
    switch (this.value){
      case 'profile':
        // window.location.href = 'https://10.202.8.44/muir/ui/profile';
        // this.onClickDisplayName();
        break;

      case 'logout':
        this.logout();
        break;
      case 'logoutAll':
        this.logout();
        break;
    }
    // this.showUserProfileDropdown = !this.showUserProfileDropdown;
  }

  isMSSPCheck(masterMSSPId: any) {
    if (this.msspOptions.length === 0 || this.selectedMssp === 'defaultId') {
      return true;
    }
    return masterMSSPId === +(this.selectedMssp);
  }

  get iconRotation() {
    return this.msspMenuOpened ? 180 : 90;
  }

  get msspOptions(): SelectOption[] {
    return this.arrayMsspLists.length > 0 ? this.arrayMsspLists : [];
  }

  unifiedReportsClick() {
    console.warn(this.navigateReportUrl);
    if (this.navigateReportUrl && this.navigateReportUrl.length) {
      let url = '';
      this.getAccessCode('ISNSMSAFEENABLED')
      .then(() => {
        url = `${this.navigateReportUrl}&code=${this.accessCode}`;
        window.location.href = url;
      });
    } else {
      const message: InfoState = {
        infoType: 'major',
        infoMsg: this.$t('spog.homepage.msg5')
        .toString(),
      };
      this.$store.commit('displayMessage', message);
    }
  }

  get clickPopoverValue(): PopoverDirValues {
    return {
      content: h => this.viewMSWAppsRender(h),
      noPadding: true,
      withCloseIcon: false,
      trigger: 'controlled',
      maxHeight: 336,
      maxWidth: 800,
      visible: this.showMSWApps,
      onClickOutsidePopper: () => { this.showMSWApps = false; },
    };
  }

  showMSWAppTray() {
    this.showMSWApps = !this.showMSWApps;
  }

  async created() {
    this.setIntervalToCheckExpiration();
    window.addEventListener('storage', (event : StorageEvent) => {
      if (this.workOnEventListener) {
        if (localStorage.getItem(currentUserKey) !== null) {
          try {
            if (JSON.parse(localStorage.getItem(currentUserKey) as any).token) {
              this.workOnEventListener = true;
            } else {
              console.warn('logout is called in try else');
              this.logout();
            }
          } catch (error) {
            console.warn('logout is called in catch');
            this.logout();
          }
        } else {
          console.warn('logout is called in else');
          this.logout();
        }
        console.warn(event);
      }
      // if (event.key === currentUserKey) {
      //   const newSnap: string = event.newValue ? event.newValue : '';
      //   const oldSnap: string = event.oldValue ? event.oldValue : '';
      //   if (oldSnap !== '' && newSnap !== '' && newSnap !== oldSnap) {
      //     if (document.hidden) {
      //       this.logout();
      //     }
      //   }
      // }
    });
    console.warn('reflect final');
    document.addEventListener('keyup', (evt : any) => {
      if (evt.keyCode === 27) {
        this.showPopUp ? this.showPopUp = false : '';
      }
    });
    if (envCongif.env === 'PROD') {
      this.capturecloudhelpurl = 'https://www.sonicwall.com/support/technical-documentation/docs/capture_security_center-user_guide/Content/administration_guide.htm/';
    }
    this.imageHoverstring = 'Click to change image';
    this.token = JSON.parse(localStorage.getItem(currentUserKey) as any).token;
    if (this.$route.query['token']) {
      this.token = this.$route.query['token'];
      const decodedToken : any = decode(this.token);
      console.warn('token is saved');
      if (decodedToken) {
        this.bispoguser = false;
        if (decodedToken.clientId === 'GMSB5C64F1SPOG' || decodedToken.clientId === 'B9C8GF1SPOGPRO') {
          this.bispoguser = true;
        }
        if (localStorage.getItem('username')) {
          localStorage.removeItem('username');
        }
        localStorage.setItem('username', this.activeTenantName);
        this.$store.commit('stopLoading');
        this.preserveUserInfo(decodedToken, this.token, this.bispoguser);
        // this.$store.dispatch('preserveUserInfo', res);
        // this.loginService.setReceivedToken(decodedtok, this.token, bispoguser);
      }
    }
    // CHECK FOR SPOG REPORTS USER ROLE
    this.currentUserRoles = JSON.parse(localStorage.getItem(currentUserKey) as any).roles || [];
    if (this.currentUserRoles.length && this.currentUserRoles.indexOf('SPOGREPORTS') !== -1) {
      this.isSpogReportsUser = true;
    } else {
      this.isSpogReportsUser = false;
    }

    this.username = JSON.parse(localStorage.getItem(currentUserKey) as any).displayName || '';
    this.email = JSON.parse(localStorage.getItem(currentUserKey) as any).email || '';
    // this.$route.query['SN']
    const userName = JSON.parse(localStorage.getItem(currentUserKey) as any).displayName
    .split(' ');
    this.displayShortName = userName[0]?.charAt(0) + userName[1]?.charAt(0);
    console.warn(JSON.parse(localStorage.getItem(currentUserKey) as any).displayName);
    // tslint:disable-next-line:max-line-length
    this.profileorlogout.push({ id: 'profile', label: JSON.parse(localStorage.getItem(currentUserKey) as any).displayName, value:JSON.parse(localStorage.getItem(currentUserKey) as any).displayName });
    this.profileorlogout.push({
      id: 'logout',
      label: this.$t('pilltooltip.logout')
      .toString(),
      value: 'Logout',
    });
    // this.flagstatus = localStorage.getItem('isaccountsmswredirect')
    // ?.toString()
    // .replace(/["]+/g, '');
    // const accountsFlag:any = localStorage.getItem('isaccountsmswredirect');
    // this.flagstatus = JSON.parse(accountsFlag);
    // if (localStorage.getItem('isaccountsmswredirect') && this.flagstatus === 'YES') {
    //   console.warn('account redirect flag check');
    //   this.profileorlogout.push({
    //     id: 'logoutAll',
    //     label:  this.$t('pilltooltip.logoutAll')
    //     .toString(),
    //     value: 'Logout All',
    //   });
    // }
    const currentUserData = JSON.parse(localStorage.getItem('currentUser') || '');
    const decodedToken : any = decode(currentUserData.token);
    this.showAppTrayBypClid = decodedToken.pClid || '';
    this.$store.commit('mutate', { property: 'pCLid', with: decodedToken.pClid });
    if (this.showAppTrayBypClid === 'ACCOUNTSMSW312312') {
      console.warn('account redirect flag check');
      this.profileorlogout.push(
        {
          id: 'logoutAll',
          label: this.$t('pilltooltip.logoutAll')
          .toString(),
          value: 'Logout All',
        },
      );
      await this.getApplications();
    }
    if (JSON.parse(localStorage.getItem(currentUserKey) as any).email === 'demo@srademo.com') {
      this.isdemouser = true;
    }
    if (JSON.parse(localStorage.getItem(currentUserKey) as any).roles
    .includes('SPOGREADONLY')) {
      this.isreadonlyuser = true;
      this.imageHoverstring = '';
      for (let i = 0; i < this.licensemysonicwall.length; i = i + 1) {
        if (this.licensemysonicwall[i].serviceName === 'MYSONICWALL' || this.licensemysonicwall[i].serviceName === 'LICENSES') {
          this.licensemysonicwall[i].isEnabled = false;
        }
      }
    }
    if (JSON.parse(localStorage.getItem(currentUserKey) as any).roles
    .includes('RISKMETERBETA')) {
      this.isriskmeterbeta = true;
    }
    if (this.$route.query['mode'] && this.$route.query['mode'] === 'tileclick') {
      if (this.$route.query['tenantver'] === '1.7') {
        this.selectInNSMSlider = 1;
      } else if (this.$route.query['tenantver'] === '2.0') {
        this.selectInNSMSlider = 2;
      }
      this.mode = 'tileclick';
      if (this.$route.query['tenantid'] && this.$route.query['tenantid'] !== '') {
        // this.selTenant = this.$route.query['tenantid'].toString();
        this.requestedTenant = this.$route.query['tenantid'].toString();
      }
      if (this.$route.query['serialnumber'] && this.$route.query['serialnumber'] !== '') {
        this.serNumberTileClick = this.$route.query['serialnumber'];
      }
      if (this.requestedTenant === '' && this.serNumberTileClick === '') {
        this.mode = '';
      }
    }
    if (this.$route.query['demo'] === 'YES') {
      this.isdemo = true;
    }
    if (this.$route.query['stile']) {
      this.demoTile = this.$route.query['stile'].toString();
    }
    // if (this.$route.query['embed'] !== undefined && this.$route.query['embed'] === 'YES'  && this.inIframe()) {
    if (this.inIframe()) {
      this.embedView = true;
      this.showContainer = true;
    } else {
      this.showContainer = false;
      console.warn(this.showContainer);
    }
    if (this.$route.query['tenant']) {
      this.requestedTenant = this.$route.query['tenant'].toString();
    } else if (this.$route.query['tenantid']) {
      this.requestedTenant = this.$route.query['tenantid'].toString();
    } else if (localStorage.getItem('tenant')) {
      if (localStorage.getItem('username')) {
        localStorage.removeItem('username');
      }
      localStorage.setItem('username', this.activeTenantName);
      this.requestedTenant = (localStorage.getItem('tenant') as any)
      .toString();
      // localStorage.removeItem('tenant');
    }
    const isdirectRedirect: boolean = (this.$route.query['mode'] &&
      this.$route.query['stile'] &&
      this.$route.query['mode'] === 'tileclick' &&
      this.$route.query['stile'] !== '') || false;
    if (isdirectRedirect) {
      this.loadTenants(true);
    } else {
      this.loadTenants();
    }
    // tslint:disable-next-line:no-this-assignment
    // const thisNew = this;
    window.addEventListener('message',  (event : any) => {
      if (event.data.closedCurtain) {
        // if (event.data.service === 'wifiplannerpopup') {
        //   window.top.location.href = event.data.navigateUrl;
        // }  else {
        //   thisNew.transition(event.data.service, event.data.navigateUrl);
        // }
      } else if (event.data.reloadCSC) {
        idb.refreshStore(CSC_STORE_NAME);
        // this.loadTenants(true);
      }
    });
    await this.getLandingAppApi();
  }

  mounted() {
    this.loadScreenViewGA();
  }

  loadScreenViewGA() {
    const currentUserT: string = localStorage.getItem(currentUserKey) || '';
    const token = currentUserT && JSON.parse(currentUserT) ? JSON.parse(currentUserT).token : '';
    // tslint:disable
    gtag('set', { 'user_id': (decode(token) as any).userName });
    gtag('event', 'screen_view', {
      'partner_tier': (decode(token) as any).partnerTier || 'NA',
      'company_name': (decode(token) as any).companyName || 'NA',
      'country_code': (decode(token) as any).countryCode || 'NA',
      'username': (decode(token) as any).userName || 'NA',
    });
    // tslint:enable
  }

  loadTenants(refresh = false) {
    this.arrayMsspLists = [];
    this.selectedMssp = 'defaultId';
    Promise.all([
      // tslint:disable-next-line:max-line-length
      this.$store.dispatch(`SpogHomepageStoreModule/${(JSON.parse(localStorage.getItem(currentUserKey) as any)?.email === 'demo@srademo.com') ? 'getTenantDetailWithoutCache' : 'getTenantDetail' }`, refresh),
      this.$store.dispatch('getAppVersion'),
    ])
    .then((response) => {
      console.warn(response);
      this.appVersion = `Version : ${response[1]?.content?.cscVersion || ''}`;
      const result = response[0];
      this.arrTenantOptions = result.content.arrTenantOptions;
      if (result.operationStatus === 'OK') {
        this.searchText = '';
        this.respContent = result.content;
        this.showVdoPopUp = result.content.isVideoPopup && !refresh && this.demoTile === '';
        this.wnmVdo = result.content.WNMVideoUrl;
        // console.warn('isInsightsQSG', JSON.stringify(result.content.isInsightsQSG));
        result.content.isInsightsQSG ? localStorage.setItem('isInsightsQSG', result.content.isInsightsQSG) : '';
        // tslint:disable-next-line:max-line-length
        this.isInsightsEnbled =  true;
        if (result.content.arrTenants) {
          this.showContainer = true;
          console.warn(this.showContainer);
          this.$store.commit('stopLoading');
          this.tenantList = result.content.arrTenants;
          console.warn(this.tenantList);
          this.filteredTenants = this.tenantList;
          const msspLists = result?.content?.arrMSSPList || [];
          this.arrayMsspLists = msspLists?.map((ele: any) => {
            return {
              id: `${ele.masterMSSPId.toString()}`,
              label: ele.msspName.toString(),
              value: `${ele.masterMSSPId.toString()}`,
            };
          }) || [];
          this.arrayMsspLists.length > 0 &&
          this.arrayMsspLists.unshift({
            id: 'defaultId',
            label: this.$t('downloadcenter.all')
            .toString(),
            value:'defaultId',
          });
        } else {
          this.showContainer = true;
          this.$store.commit('stopLoading');
          const message: InfoState = { infoType: 'failed', infoMsg: result.msgDesc };
          this.$store.commit('enqueueMessage', message);
          this.tenantList = [];
          this.filteredTenants = [];
        }
        this.assignTenantSettings();
      } else {
        const message: InfoState = { infoType: 'high', infoMsg: result.msgDesc };
        this.$store.commit('displayMessage', message);
        this.$store.commit('stopLoading');
      }
    })
    .catch((e: any) => {
      console.error('loadTenants api error:-', e);
    });
  }

  tenantSelected(tenant : any, index : any) {
    // this.showCheckBoxPopup = false;
    localStorage.setItem('tenantname', tenant.name);
    this.showPopUp = false;
    console.warn(index);
    this.showCheckBoxPopup =  false;
    this.showNsmSliderAfterPopUp = true;
    this.selTenant = tenant.name;
    this.showTenantDropDown = false;
    this.showSSC = false;
    this.activeTenantId = tenant.productGroupID;
    this.activeTenantName = tenant.name;
    this.activeTenantEncName = tenant.encname;
    this.activeServices = tenant.cloudServices;
    if (this.activeServices[0].navigateReportUrl) {
      this.navigateReportUrl = this.activeServices[0].navigateReportUrl;
    } else {
      this.navigateReportUrl = '';
    }
    this.serviceSelected = this.activeServices.filter((ele : any) => {
      if (ele.serviceName === 'NGMGMT' || ele.serviceName.indexOf('Management') > -1) {
        return ele;
      }
    });
    if (this.serviceSelected[0]) {
      console.warn(this.serviceSelected[0]);
      if (this.serviceSelected[0].migrateList.length > 0) {
        this.nsmServiceLength1 = 0;
        this.nsmServiceLength2 = 0;
        this.nsm2 = this.serviceSelected[0].migrateList;
        console.warn(this.nsm2);
        this.nsm2.forEach((each: any) => {
          if (each.NFR === '11') {
            this.nsmServiceLength1 += 1;
          } else {
            this.nsmServiceLength2 += 1;
          }
        });
      } else {
        this.nsmServiceLength1 = 0;
        this.nsmServiceLength2 = 0;
      }
    } else {
      this.nsmServiceLength1 = 0;
      this.nsmServiceLength2 = 0;
    }
    this.showHoverOverMessage = [];
    this.showToolTip = [];
    this.showWarnToolTip = [];
    this.activeServices.forEach((element : any) => {
      this.showHoverOverMessage.push(false);
      this.showWarnToolTip.push(false);
      this.showToolTip.push(false);
      if (element.serviceName === 'CAS') {
        this.casburl = element.navigateUrl;
      } else if (element.serviceName === 'Cloud Email') {
        this.cloudemailurl = element.navigateUrl;
      } else if (element.serviceName === 'CES') {
        this.cloudemailsecurityurl = element.navigateUrl;
      } else if (element.serviceName === 'CaaS') {
        this.caasurl = element.navigateUrl;
      } else if (element.serviceName === 'SMA') {
        this.smaurl = element.navigateUrl;
      } else if (element.serviceName === 'NGMGMT') {
        this.ngmgmturl = element.navigateUrl;
      } else if (element.serviceName === 'CAS2.0') {
        this.cas2url = element.navigateUrl;
      } else if (element.serviceName === 'SASI') {
        this.saseurl = element.navigateUrl;
      } else if (element.serviceName.toUpperCase() === 'WIFIPLANNER') {
        this.wifiplannerurl = element.navigateUrl;
      } else if (element.serviceName === 'Cloud WAF') {
        this.wafurl = element.navigateUrl;
      } else if (element.serviceName === 'Wireless') {
        this.wirelessurl = element.navigateUrl;
      } else if (element.serviceName === 'CSE') {
        this.cseUrl = element.navigateUrl;
      } else if (element.serviceName === 'TSE') {
        this.tseUrl = element.navigateUrl;
      } else if (element.serviceName === 'TSEMDR') {
        this.tseMDRUrl = element.navigateUrl;
      }
    });
  }
  checkIfServiceExist(demoTile : any) {
    switch (demoTile) {
      case 'CAS': return this.checkForService('CAS'); break;
      // case 'MGMT': return this.checkForService('MANAGEMENT'); break;
      case 'NSM': return this.checkForService('NSM'); break;
      // case 'FW Management': return this.checkForService('NGMGMT'); break;
      case 'RPT': return this.checkForService('REPORTS'); break;
      case 'ANLT': return this.checkForService('ANALYTICS'); break;
      case 'CCLT': return this.checkForService('CAPTURE CLIENT'); break;
      case 'MDR': return this.checkForService('MDR'); break;
      case 'CAS2.0': return this.checkForService('CAS2.0'); break;
      case 'SASE': return this.checkForService('SASI'); break;
      case 'Cloud Email': return this.checkForService('Cloud Email'); break;
      case 'CES': return this.checkForService('CES'); break;
      case 'SMA': return this.checkForService('SMA'); break;
      case 'CSE': return this.checkForService('CSE'); break;
      case 'TSE': return this.checkForService('TSE'); break;
      case 'TSEMDR': return this.checkForService('TSEMDR'); break;
      case 'MSW': return true; break;
      case 'WCM': return this.checkForService('WIRELESS'); break;
      default: const message: InfoState = {
        infoType: 'high',
        infoMsg: this.$t('spog.homepage.msg1')
        .toString(),
      };
        this.$store.commit('displayMessage', message);
        break;
    }
  }

  checkForService(serviceName : any, returnService = false) {
    let checkFlag = true;
    let service : any;
    if (serviceName === 'NSM') {
      if (!this.activeServices[0].isEnabled) {
        const message: InfoState = {
          infoType: 'high',
          infoMsg:  this.$t('spog.homepage.msg2')
          .toString(),
        };
        this.$store.commit('displayMessage', message);
        checkFlag = false;
      } else if (this.activeServices[0].isNoAccess) {
        const message: InfoState = {
          infoType: 'high',
          infoMsg: this.$t('spog.homepage.msg3')
          .toString(),
        };
        this.$store.commit('displayMessage', message);
        checkFlag = false;
      }
    } else {
      this.activeServices.forEach((ele : any) => {
        if (ele.serviceName.toLowerCase() === serviceName.toLowerCase()) {
          service = ele;
          if (!ele.isEnabled) {
            const message: InfoState = {
              infoType: 'high',
              infoMsg: this.$t('spog.homepage.msg2')
              .toString(),
            };
            this.$store.commit('displayMessage', message);
            checkFlag = false;
          } else if (ele.isNoAccess) {
            const message: InfoState = {
              infoType: 'high',
              infoMsg: this.$t('spog.homepage.msg3')
              .toString(),
            };
            this.$store.commit('displayMessage', message);
            checkFlag = false;
          }
        }
      });
    }
    if (!service && serviceName !== 'NSM') {
      const message: InfoState = {
        infoType: 'high',
        infoMsg: this.$t('spog.homepage.msg2')
        .toString(),
      };
      this.$store.commit('displayMessage', message);
      checkFlag = false;
    }
    return returnService ? service : checkFlag;
  }

  assignTenantSettings() {
    if (this.tenantList.length > 0) {
      if (this.mode === 'tileclick') {
        // tslint:disable-next-line:max-line-length
        if ((this.requestedTenant === '' || this.requestedTenant === undefined || this.requestedTenant === '0' || this.tenantList.filter((item : any) => item.productGroupID.toString() === this.requestedTenant.trim()).length === 0) && this.serNumberTileClick) {
          this.$store.commit('startLoading');
          this.$store.dispatch('SpogHomepageStoreModule/getProductDetail', this.serNumberTileClick)
          .then((res) => {
            if (res.operationStatus === 'OK') {
              this.requestedTenant = res.content.pDetail[0].groupid;
              this.afterRequestedTenantSelection();
              this.assignUrl();
              this.tileClickRedirect();
            } else {
              this.requestedTenant = '';
              const message: InfoState = {
                infoType: 'high',
                infoMsg: this.$t('spog.homepage.msg4')
                .toString(),
              };
              this.$store.commit('displayMessage', message);
            }
            this.$store.commit('stopLoading');
            console.warn(res.content.pDetail[0].groupid);
          });
        } else {
          this.afterRequestedTenantSelection();
          this.assignUrl();
          this.tileClickRedirect();
        }
      } else if (this.requestedTenant !== '' && this.requestedTenant !== undefined) {
        let ind = this.tenantList.findIndex((element : any) => element.productGroupID.toString() === this.requestedTenant.trim());
        if (ind === -1) {
          ind = 0;
          this.activeServices = this.tenantList[ind].cloudServices;
        } else {
          this.activeServices = this.tenantList[ind].cloudServices;
        }
        this.serviceSelected = this.activeServices.filter((ele : any) => {
          if (ele.serviceName === 'NGMGMT' || ele.serviceName.indexOf('Management') > -1) {
            return ele;
          }
        });

        console.warn(this.serviceSelected);
        console.warn(this.serviceSelected[0].navigateReportUrl);

        if (this.serviceSelected[0].navigateReportUrl) {
          this.navigateReportUrl = this.serviceSelected[0].navigateReportUrl;
        } else {
          console.warn('donesnt have');
          this.navigateReportUrl = '';
        }

        if (this.serviceSelected[0]) {
          if (this.serviceSelected[0].migrateList.length > 0) {
            this.serviceSelected[0].migrateList.forEach((each: any) => {
              if (each.NFR === '11') {
                this.nsmServiceLength1 += 1;
              } else {
                this.nsmServiceLength2 += 1;
              }
            });
          } else {
            this.nsmServiceLength1 = 0;
            this.nsmServiceLength2 = 0;
          }
        } else {
          this.nsmServiceLength1 = 0;
          this.nsmServiceLength2 = 0;
        }
        this.activeTenantId = this.tenantList[ind].productGroupID;
        this.activeTenantName = this.tenantList[ind].name;
        this.selTenant = this.tenantList[ind].name;
        this.activeTenantEncName = this.tenantList[ind].encname;
        this.assignUrl();
      } else {
        let tenantIndex : any = 0;
        if (localStorage.getItem('tenantname') !== null) {
          this.selTenant = localStorage.getItem('tenantname')!;
        }
        if (this.selTenant !== '') {
          this.tenantList.forEach((each: any, index : any) => {
            if (each.name === this.selTenant) {
              tenantIndex = index;
            }
          });
        }
        this.activeTenantId = this.tenantList[tenantIndex].productGroupID;
        this.activeTenantName = this.tenantList[tenantIndex].name;
        this.selTenant = this.tenantList[tenantIndex].name;
        console.warn(this.selTenant);
        this.activeTenantEncName = this.tenantList[tenantIndex].encname;
        this.activeServices = this.tenantList[tenantIndex].cloudServices;
        this.serviceSelected = this.activeServices.filter((ele : any) => {
          if (ele.serviceName === 'NGMGMT' || ele.serviceName.indexOf('Management') > -1) {
            return ele;
          }
        });
        console.warn(this.serviceSelected);
        this.setNSMItemLists();
        this.assignUrl();
      }
    }
  }
  setNSMItemLists() {
    if (this.serviceSelected[0]) {
      if (this.serviceSelected[0].migrateList.length > 0) {
        this.nsmServiceLength1 = 0;
        this.nsmServiceLength2 = 0;
        this.nsm2 = this.serviceSelected[0].migrateList;
        this.serviceSelected[0].migrateList.forEach((each: any) => {
          if (each.NFR === '11') {
            this.nsmServiceLength1 += 1;
          } else {
            this.nsmServiceLength2 += 1;
          }
        });
      } else {
        this.nsmServiceLength1 = 0;
        this.nsmServiceLength2 = 0;
      }
    } else {
      this.nsmServiceLength1 = 0;
      this.nsmServiceLength2 = 0;
    }
  }
  tileClickRedirect() {
    if (this.demoTile && !this.wrongInputInTileClick && this.checkIfServiceExist(this.demoTile)) {
      let service = this.activeServices.filter((ele : any) => ele.serviceName.toLowerCase() === this.demoTile.toLowerCase());
      if (service.length === 0 && this.demoTile === 'NSM') {
        service = [this.activeServices[0]];
      }
      console.warn(service);
      switch (this.demoTile) {
        case 'CAS': this.clickservice(false, true, 'CAS', '', '', service.length > 0 ? service[0] : ''); this.transition('CAS'); break;
        // case 'MGMT': this.clickservice(false, true, 'MANAGEMENT', '', '', service.length > 0 ? service[0] : ''); this.transition('MANAGEMENT'); break;
        case 'NSM': this.clickservice(false, true, this.activeServices[0].serviceName, '', '', service.length > 0 ? service[0] : ''); break;
            // tslint:disable-next-line:max-line-length
        // case 'FW Management': this.clickservice(false, true, 'FW Management', '', '', service.length > 0 ? service[0] : ''); break;
        case 'RPT': this.clickservice(false, true, 'REPORTS', '', '', service.length > 0 ? service[0] : ''); this.transition('REPORTS'); break;
        case 'ANLT': this.clickservice(false, true, 'ANALYTICS', '', '', service.length > 0 ? service[0] : ''); this.transition('ANALYTICS'); break;
            // tslint:disable-next-line:max-line-length
        case 'CCLT': this.clickservice(false, true, 'CAPTURE CLIENT', '', '', service.length > 0 ? service[0] : ''); this.transition('CAPTURE CLIENT'); break;
        case 'MDR': this.clickservice(false, true, 'MDR', '', '', service.length > 0 ? service[0] : ''); this.transition('MDR'); break;
        case 'CAS2.0': this.clickservice(false, true, 'CAS2.0', '', '', service.length > 0 ? service[0] : ''); this.transition('CAS2.0'); break;
        case 'SASE': this.clickservice(false, true, 'SASI', '', '', service.length > 0 ? service[0] : ''); this.transition('SASE'); break;
            // tslint:disable-next-line:max-line-length
        case 'Cloud Email': this.clickservice(false, true, 'Cloud Email', '', '', service.length > 0 ? service[0] : ''); this.transition('Cloud Email'); break;
        case 'CES': this.clickservice(false, true, 'CES', '', '', service.length > 0 ? service[0] : ''); this.transition('CES'); break;
        case 'SMA': this.clickservice(false, true, 'SMA', '', '', service.length > 0 ? service[0] : ''); this.transition('SMA'); break;
        case 'MSW': this.clickservice(false, this.licensemysonicwall[1].isEnabled, 'MYSONICWALL', '', '', ''); break;
        case 'CSE': this.clickservice(false, true, 'CSE', '', '', service.length > 0 ? service[0] : ''); this.transition('CSE'); break;
        case 'TSE': this.clickservice(false, true, 'TSE', '', '', service.length > 0 ? service[0] : ''); this.transition('TSE'); break;
        case 'TSEMDR': this.clickservice(false, true, 'TSEMDR', '', '', service.length > 0 ? service[0] : ''); this.transition('TSEMDR'); break;
        case 'WCM': this.clickservice(false, true, 'Wireless', '', '', service.length > 0 ? service[0] : ''); this.transition('Wireless'); break;
      }
    }
  }
  afterRequestedTenantSelection() {
    let filteredlist:any;
    filteredlist = this.tenantList.find((item : any) => item.productGroupID.toString() === this.requestedTenant.trim());
    if (filteredlist === undefined || filteredlist === null) {
      if (this.mode === 'tileclick') {
        if (this.forcedReloadwhenTileClickDone) {
          const message: InfoState = { infoType: 'high', infoMsg: 'Please send correct tenant Id.' };
          this.$store.commit('displayMessage', message);
          filteredlist = this.tenantList[0];
          this.wrongInputInTileClick = true;
        } else {
          this.forcedReloadwhenTileClickDone = true;
          this.loadTenants(true);
          return;
        }
      } else {
        const message: InfoState = { infoType: 'high', infoMsg: 'Please send correct tenant Id.' };
        this.$store.commit('displayMessage', message);
        filteredlist = this.tenantList[0];
        this.wrongInputInTileClick = true;
      }
    }
    if (filteredlist !== null && filteredlist !== undefined) {
      this.activeServices = filteredlist.cloudServices;
      this.serviceSelected = this.activeServices.filter((ele : any) => {
        if (ele.serviceName === 'NGMGMT' || ele.serviceName.indexOf('Management') > -1) {
          return ele;
        }
      });
      console.warn(this.serviceSelected);
      if (this.serviceSelected[0]) {
        if (this.serviceSelected[0].migrateList.length > 0) {
          this.nsmServiceLength1 = 0;
          this.nsmServiceLength2 = 0;
          this.serviceSelected[0].migrateList.forEach((each: any) => {
            if (each.NFR === '11') {
              this.nsmServiceLength1 += 1;
            } else {
              this.nsmServiceLength2 += 1;
            }
          });
        } else {
          this.nsmServiceLength1 = 0;
          this.nsmServiceLength2 = 0;
        }
      } else {
        this.nsmServiceLength1 = 0;
        this.nsmServiceLength2 = 0;
      }
      this.activeTenantId = filteredlist.productGroupID;
      this.activeTenantName = filteredlist.name;
      this.selTenant = filteredlist.name;
      this.activeTenantEncName = filteredlist.encname;
    }
  }
  assignUrl() {
    this.showHoverOverMessage = [];
    this.showToolTip = [];
    this.showWarnToolTip = [];
    this.activeServices.forEach((element : any) => {
      this.showHoverOverMessage.push(false);
      this.showWarnToolTip.push(false);
      this.showToolTip.push(false);
      if (element.serviceName === 'CAS') {
        this.casburl = element.navigateUrl;
        console.warn(this.casburl);
      }
      if (element.serviceName === 'Cloud Email') {
        this.cloudemailurl = element.navigateUrl;
      }
      if (element.serviceName === 'CES') {
        this.cloudemailsecurityurl = element.navigateUrl;
      }
      if (element.serviceName === 'CaaS') {
        this.caasurl = element.navigateUrl;
      }
      if (element.serviceName === 'SMA') {
        this.smaurl = element.navigateUrl;
      }
      if (element.serviceName === 'NGMGMT') {
        this.ngmgmturl = element.navigateUrl;
      }
      if (element.serviceName === 'CAS2.0') {
        this.cas2url = element.navigateUrl;
      }
      if (element.serviceName === 'SASI') {
        this.saseurl = element.navigateUrl;
      }
      if (element.serviceName.toUpperCase() === 'WIFIPLANNER') {
        this.wifiplannerurl = element.navigateUrl;
      }
      if (element.serviceName === 'Cloud WAF') {
        this.wafurl = element.navigateUrl;
      }
      if (element.serviceName === 'Wireless') {
        this.wirelessurl = element.navigateUrl;
      }
      if (element.serviceName === 'CSE') {
        this.cseUrl = element.navigateUrl;
      }
      if (element.serviceName === 'TSE') {
        this.tseUrl = element.navigateUrl;
      }
      if (element.serviceName === 'TSEMDR') {
        this.tseMDRUrl = element.navigateUrl;
      }
    });
  }
  clickservice(close = false, serviceAvailable = true, service = '', navigateUrl = '', avaiableRatio = '', serviceJson: any) {
    if (serviceAvailable) {
      const uid = JSON.parse(localStorage.getItem(currentUserKey) as any).userId;
      // tslint:disable
      gtag('set', { 'user_id': uid });
      gtag('event', 'service_click', {
        'event_category' : 'click',
        'event_label' : service,
        'value': service,
      });
      // tslint:enable
    }
    this.nsmNewUrl = false;
    this.nsmOldUrlSelected = false;
    let hasAccess = true;
    if ((service.toUpperCase()
    .indexOf('MANAGEMENT') > -1 || service.toUpperCase()
    .indexOf('NGMGMT') > -1)  && serviceJson.navigateUrl) {
      this.nsmNewUrl = true;
    }
    // disabling service when no access is true
    if (serviceJson.hasOwnProperty('isNoAccess')) {
      hasAccess = !serviceJson.isNoAccess;
    }
    if (service.toUpperCase() === 'MANAGEMENT') {
      // tslint:disable-next-line:no-parameter-reassignment
      service = 'FW MANAGEMENT';
    }
    this.cgmsArrTenants = undefined;
    this.cgmsClose = undefined;
    this.cgmsServiceAvailable = undefined;
    this.cgmsService = undefined;
    this.cgmsMode = undefined;
    if (service.toUpperCase() === 'WIRELESS' && hasAccess && serviceAvailable && avaiableRatio !== '' && avaiableRatio.indexOf('0 of') === 0) {
      if (this.mode === 'tileclick') {
        this.launchWifiPlanner();
      } else {
        if (this.respContent.isWNMPopup && !this.embedView) {
          this.showWNMVdoPopup = true;
        } else {
          this.showFirewallDialog = true;
        }
      }
      return;
    }
    if (serviceAvailable && hasAccess) {
      console.warn('here');
      if (service.toUpperCase() !== 'ANALYTICS' && service.toUpperCase() !== 'FW MANAGEMENT' && service.toUpperCase() !== 'REPORTS') {
        this.trackGAEvents('SPOGHomePgClick', service);
        if (localStorage.getItem('tenant')) {
          localStorage.removeItem('tenant');
        }
        localStorage.setItem('tenant', this.activeTenantId);
        if (localStorage.getItem('tenantname')) {
          localStorage.removeItem('tenantname');
        }
        localStorage.setItem('tenantname', this.activeTenantName);
        if (service.toUpperCase() === 'NGMGMT' && this.respContent.isNSSMPopup) {
          if (this.showPopUp && !this.showCheckBoxPopup) {
            this.showCheckBoxPopup = false;
          } else {
            this.showCheckBoxPopup = true;
          }
        }
        if (service.toUpperCase() === 'NGMGMT') {
          if (serviceJson.showSlider === 'YES') {
            this.setNSMItemLists();
            if (this.selectInNSMSlider === 1 || this.selectInNSMSlider === 2) {
              this.navigateNSM(this.selectInNSMSlider);
            } else if (this.mode === 'tileclick') {
              this.navigateNSM(2);
            }
            this.showPopUp = this.showCheckBoxPopup ? this.showPopUp : !this.showPopUp;
          } else if (this.showCheckBoxPopup) {
            this.showNsmSliderAfterPopUp = false;
          } else {
            this.toggleCurtain(close, serviceAvailable, service, navigateUrl);
          }
        } else {
          this.toggleCurtain(close, serviceAvailable, service, navigateUrl);
        }
        return;
      }
      if (service.toUpperCase() === 'FW MANAGEMENT') {
        let cgmsarr : any;
        this.tenantList.forEach((each : any) => {
          if (each.name === this.selTenant) {
            cgmsarr = each.cgmsTenants;
          }
        });
        if (cgmsarr !== undefined) {
          if (cgmsarr.length === 1) {
            this.cgmsurl = cgmsarr[0].launchUrl;
            this.cgmsser = cgmsarr[0].serialNumber;
            // this.toggleCurtain(close, serviceAvailable, service);
          }
          if (cgmsarr.length > 1) {
            this.cgmsArrTenants = cgmsarr;
            this.cgmsMode = 'Management';
            this.cgmsClose = close;
            this.cgmsServiceAvailable = serviceAvailable;
            this.cgmsService = service;
            // this.sidenav.toggle()
          }
        }
        if (this.showPopUp && !this.showCheckBoxPopup) {
          this.showCheckBoxPopup = false;
        } else if (this.respContent.isNSSMPopup) {
          this.showCheckBoxPopup = true;
        }
        if (service.toUpperCase() === 'FW MANAGEMENT' && serviceJson.showSlider === 'YES') {
          if (this.selectInNSMSlider === 1 || this.selectInNSMSlider === 2) {
            this.navigateNSM(this.selectInNSMSlider);
          }
          this.showPopUp = this.showCheckBoxPopup ? this.showPopUp : !this.showPopUp;
        } else if (this.showCheckBoxPopup) {
          this.showNsmSliderAfterPopUp = false;
        } else {
          if (cgmsarr !== undefined) {
            if (cgmsarr.length === 1) {
              this.toggleCurtain(close, serviceAvailable, service);
            } else {
            // this.sidenav.toggle() demo
            }
          }
        }
        return;
      }
      if (service.toUpperCase() === 'ANALYTICS' || service.toUpperCase() === 'REPORTS') {
        // It is a CGMS. Find out if there is one or more tenants
        let analyticsarr : any;
        this.tenantList.forEach((each : any) => {
          if (each.name === this.selTenant) {
            analyticsarr = each.analyticsTenants;
          }
        });
        if (analyticsarr !== undefined) {
          if (analyticsarr.length === 1) {
            this.analyticsurl = analyticsarr[0].launchUrl;
            this.analyticsser = analyticsarr[0].serialNumber;
            this.toggleCurtain(close, serviceAvailable, service.toUpperCase());
          }
          if (analyticsarr.length > 1) {
            this.cgmsArrTenants = analyticsarr;
            this.cgmsMode = 'analytics';
            this.cgmsClose = close;
            this.cgmsServiceAvailable = serviceAvailable;
            this.cgmsService = service;
            // this.sidenav.toggle();
          }
        }
      }
    }
  }
  closeWirelessDialog() {
    console.warn('closed dialog');
    this.showVdoPopUp = false;
    this.showImageUpload = false;
    this.showFirewallDialog = false;
    if (this.showWNMVdoPopup) {
      if (this.wnmRedirectUrlAfterVdo === '') {
        this.showFirewallDialog = true;
      } else {
        window.top.location.href = this.wnmRedirectUrlAfterVdo;
      }
    }
    this.showWNMVdoPopup = false;
  }
  launchWifiPlanner() {
    this.showFirewallDialog = false;
    console.warn('wifiPlanner');
    const rooturl = `${envCongif.api_url}`;
    const id = JSON.parse(localStorage.getItem(currentUserKey) as any).userId;
    const sessionID = JSON.parse(localStorage.getItem(currentUserKey) as any).sessionId;
    if (this.embedView) {
      window.parent.postMessage({
        closeCurtain: true,
        service : 'wifiplannerpopup',
        navigateUrl : `${rooturl}/partnerappsToken?username=${id}&appName=WIFIPLANNER&sessionID=${sessionID}&qsparams=` ,
      },                        '*');
    } else {
          // tslint:disable-next-line:prefer-template
      window.top.location.href = rooturl + '/partnerappsToken?username=' +
       id + '&appName=WIFIPLANNER&sessionID=' + sessionID + '&qsparams=';
    }
  }
  toggleCurtain(close = false, serviceAvailable = true, service = '', navigateUrl = '') {
    console.warn(serviceAvailable);
    if (close) {
    } else if (!this.embedView) {
      this.showContainer = false;
      this.transition(service, navigateUrl);
    } else {
      if (!envCongif.isspogTransEnabled) {
        this.transition(service, navigateUrl);
      } else {
        const services = service;
        const navigateUrls = navigateUrl;
        if (this.embedView) {
          window.parent.postMessage({
            closeCurtain: true,
            service : services,
            navigateUrl : navigateUrls,
          },                        '*');
          if (service === 'wifiplannerpopup') {
            window.top.location.href = navigateUrl;
          }  else {
            this.transition(service, navigateUrl);
          }
        } else {
          this.transition(service, navigateUrl);
        }
      }
    }
  }
  transition(service : any, navigateUrl = '') {
    console.warn(navigateUrl);
    let waittime: number = 2000;
    if (!envCongif.isspogTransEnabled) {
      waittime = 10;
    }
    if (!this.embedView) {
      this.showContainer = false;
    }
    setTimeout(() => {
      if (!this.embedView) {
        this.$store.commit('startLoading');
      }
      let srcUrl = '';
      if (service.toUpperCase() === 'FW MANAGEMENT') {
        this.makePostRequest('mgmt');
      } else if (service.toUpperCase() === 'ANALYTICS') {
        this.makePostRequest('analytics');
      } else if (service.toUpperCase() === 'REPORTS') {
        this.makePostRequest('reports');
      } else if (service.toUpperCase() === 'CAPTURE CLIENT') {
        const returnUrlQuery = `?tenant=${this.activeTenantId}&tenantName=${this.activeTenantName}`;
        const returnUrl = `${btoa(`${envCongif.spog_url}/workspace/m/feature/spog-homepage${returnUrlQuery}`)}`;
        let tokenStr = '';
        if (isSafari) {
          tokenStr = `token=${JSON.parse(localStorage.getItem(currentUserKey) as any).token}`;
        }
        const tenantStr = tokenStr ? `&tenant=${this.activeTenantId}` : `tenant=${this.activeTenantId}`;
        const spogSrc = `${btoa(`${envCongif.spog_url}${spogSrcPath}?${tokenStr}${tenantStr}&embed=YES`)}`;
        if (this.respContent && (this.respContent.isNewCCSSOEnabled === 'YES')) {
          this.getAccessCode('CCLIENT')
          .then(() => {
            const form = document.createElement('form');
            form.target = this.embedView ? 'view' : '_self';
            form.method = 'POST';
            form.action = `${envCongif.api_url}/redirect-to-application-with-code`;
            const params: any = {
              returnUrl,
              spogSrc,
              appName: 'CCLIENT',
              tenant:this.activeTenantId,
              accessCode:this.accessCode,
            };

            for (const i in params) {
              if (params.hasOwnProperty(i)) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = i;
                input.value = params[i];
                form.appendChild(input);
              }
            }
            document.body.appendChild(form);
            form.submit();
            if (this.embedView) {
              window.open('', 'view');
            }
          });
        } else {
          const userId = JSON.parse(localStorage.getItem(currentUserKey) as any).userId;
          const sessionId = JSON.parse(localStorage.getItem(currentUserKey) as any).sessionId;
          const usernameQuery = `?username=${userId}`;
          const sessionQuery = `&sessionID=${sessionId}`;
          const appNameQuery = '&appName=CCLIENT';
          const tenantQuery = `&tenant=${this.activeTenantId}`;
          const endpoint = `${envCongif.api_url}/redirect-to-application`;
          const returnURL = `&returnUrl=${returnUrl}`;
          const spogSRC = `&spogSrc=${spogSrc}`;
          const url = `${endpoint}${usernameQuery}${sessionQuery}${appNameQuery}${tenantQuery}${returnURL}${spogSRC}`;
          if (this.embedView) {
            window.open(url, '_blank');
          } else {
            window.top.location.href = url;
          }
        }
      } else if (service.toUpperCase() === 'MDR') {
        const returnUrlQuery = `?tenant=${this.activeTenantId}&tenantName=${this.activeTenantName}`;
        let tokenStr = '';
        if (isSafari) {
          tokenStr = `token=${JSON.parse(localStorage.getItem(currentUserKey) as any).token}`;
        }
        const tenantStr = tokenStr ? `&tenant=${this.activeTenantId}` : `tenant=${this.activeTenantId}`;
        const returnUrl = `${btoa(`${envCongif.spog_url}/workspace/m/feature/spog-homepage${returnUrlQuery}`)}`;
        const spogSrc = `${btoa(`${envCongif.spog_url}${spogSrcPath}?${tokenStr}${tenantStr}&embed=YES`)}`;

        if (this.respContent && (this.respContent.isNewCCSSOEnabled === 'YES')) {
          this.getAccessCode('MDR')
          .then(() => {
            const form = document.createElement('form');
            form.target = this.embedView ? 'view' : '_self';
            form.method = 'POST';
            form.action = `${envCongif.api_url}/redirect-to-application-with-code`;
            const params: any = {
              returnUrl,
              spogSrc,
              appName: 'MDR',
              tenant:this.activeTenantId,
              accessCode:this.accessCode,
            };

            for (const i in params) {
              if (params.hasOwnProperty(i)) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = i;
                input.value = params[i];
                form.appendChild(input);
              }
            }
            document.body.appendChild(form);
            form.submit();
            if (this.embedView) {
              window.open('', 'view');
            }
          });
        } else {
          const userId = JSON.parse(localStorage.getItem(currentUserKey) as any).userId;
          const sessionId = JSON.parse(localStorage.getItem(currentUserKey) as any).sessionId;
          const usernameQuery = `?username=${userId}`;
          const sessionQuery = `&sessionID=${sessionId}`;
          const appNameQuery = '&appName=MDR';
          const tenantQuery = `&tenant=${this.activeTenantId}`;
          const endpoint = `${envCongif.api_url}/redirect-to-application`;
          const returnURL = `&returnUrl=${returnUrl}`;
          const spogSRC = `&spogSrc=${spogSrc}`;
          const url = `${endpoint}${usernameQuery}${sessionQuery}${appNameQuery}${tenantQuery}${returnURL}${spogSRC}`;
          if (this.embedView) {
            window.open(url, '_blank');
          } else {
            window.top.location.href = url;
          }
        }
      } else if (service === 'CAS') {
        this.makePostRequest('cas');
      } else if (service === 'SASI') {
        this.makePostRequest('sasi');
      } else if (service === 'CAS2.0') {
        this.makePostRequest('cas2.0');
      } else if (service.toUpperCase() === 'WIFIPLANNER') {
        this.makePostRequest('wifiplanner');
      } else if (service.toUpperCase() === 'WIRELESS') {
        this.makePostRequest('wireless');
      } else if (service.toUpperCase() === 'MYSONICWALL') {
        srcUrl = this.mswUrlCreation();
        this.goToMsw(srcUrl);
      } else if (service.toUpperCase() === 'LICENSES') {
        srcUrl = `${envCongif.spog_url}/muir/spog/licenses`;
        window.top.location.href = srcUrl;
      } else if (service.toUpperCase() === 'CLOUD EMAIL') {
        this.makePostRequest('cloudemail');
      } else if (service.toUpperCase() === 'CES') {
        this.makePostRequest('cloudemailsecurity');
      } else if (service.toUpperCase() === 'CAAS') {
        this.makePostRequest('caas');
      } else if (service.toUpperCase() === 'SMA') {
        this.makePostRequest('SMA');
      } else if (service.toUpperCase() === 'NGMGMT') {
        this.makePostRequest('NGMGMT');
      } else if (service.toUpperCase() === 'CLOUD WAF') {
        this.makePostRequest('cloudwaf');
      } else if (service.toUpperCase() === 'CSE') {
        this.makePostRequest('CSE');
      } else if (service.toUpperCase() === 'TSE') {
        this.makePostRequest('TSE');
      } else if (service.toUpperCase() === 'TSEMDR') {
        this.makePostRequest('TSEMDR');
      }
    },         waittime);
  }
  mswUrlCreation(redirectUrlToTool = false) {
    let srcUrl = '';
    let str = '';
    const userRoles: string = JSON.parse(localStorage.getItem(currentUserKey) as any).roles || '';
    if (userRoles && userRoles.includes('vuemenu')) {
      str = `${envCongif.msw_url}/workspace/m/login/login-view?tok=`;
    } else {
      str = `${envCongif.msw_url}/muir/login?tok=`;
    }
    const str1 = '&sid=';
    const str2 = '&un=';
    const str3 = '&roles=';
    const str4 = '&dn=';
    const str5 = '&tenantId=';
    const str6 = '&tenantName=';
    const str7 = '&spogUser=';
    const str8 = '&REDIRECTPAGE=';
    let str9: string = '';
    if (userRoles && userRoles.includes('vuemenu')) {
      str9 = `${envCongif.msw_url}/workspace/m/feature/products?tenantid=${this.activeTenantId}`;
      if (redirectUrlToTool) {
        str9 = `${envCongif.msw_url}/workspace/m/feature/migrationTool`;
      }
    } else {
      str9 = `${envCongif.msw_url}/muir/ui/workspace/m/feature/products?tenantid=${this.activeTenantId}`;
      if (redirectUrlToTool) {
        str9 = `${envCongif.msw_url}/muir/ui/migrationTool`;
      }
    }
    srcUrl = str + JSON.parse(localStorage.getItem(currentUserKey) as any).token +
      str1 + JSON.parse(localStorage.getItem(currentUserKey) as any).sessionId +
      str2 + JSON.parse(localStorage.getItem(currentUserKey) as any).userId +
      str3 + JSON.parse(localStorage.getItem(currentUserKey) as any).roles +
      str4 + JSON.parse(localStorage.getItem(currentUserKey) as any).displayName +
      str5 + this.activeTenantId +
      str6 + Base64.encode(this.activeTenantName)  +
      str7 + true +
      str8 + btoa(str9);
    return srcUrl;
  }

  async makePostRequest(viewModeValues: any) {
    console.warn('viewmode is', viewModeValues);
    let viewModeValue = viewModeValues;
    let srcUrl: any = '';
    let spogSrc: any = '';
    let returnUrl: any = '';
    const csctoken = JSON.parse(localStorage.getItem(currentUserKey) as any).token;
    returnUrl = `${envCongif.spog_url}/workspace/m/feature/spog-homepage?embed=YES&tenant=${this.activeTenantId}`;
    spogSrc = `${envCongif.spog_url}${spogSrcPath}?embed=YES&tenant=${this.activeTenantId}`;
    if (isSafari) {
      spogSrc += `&token=${csctoken}`;
    }
    const userId = JSON.parse(localStorage.getItem(currentUserKey) as any).userId;
    const sessionId = JSON.parse(localStorage.getItem(currentUserKey) as any).sessionId;
    spogSrc = btoa(spogSrc)
    .replace('==', '')
    .replace('=', '');
    returnUrl = btoa(returnUrl)
    .replace('==', '')
    .replace('=', '');
    const domain = document.createElement('INPUT');
    const form = document.createElement('form');
    form.setAttribute('style', 'display: none;');
    form.setAttribute('method', 'POST');
    if (viewModeValue === 'mgmt') {
      domain.setAttribute('value', this.cgmsser);
      form.setAttribute('action', this.cgmsurl);
      const str = '&tenantid=';
      srcUrl = this.cgmsurl + str + this.activeTenantId;
    } else if (viewModeValue === 'analytics') {
      domain.setAttribute('value', this.analyticsser);
      form.setAttribute('action', this.analyticsurl);
      const str = '&tenantid=';
      srcUrl = this.analyticsurl + str + this.activeTenantId;
    } else if (viewModeValue === 'reports') {
      viewModeValue = 'reports';
      domain.setAttribute('value', this.analyticsser);
      form.setAttribute('action', this.analyticsurl);
      const str = '&tenantid=';
      srcUrl = this.analyticsurl + str + this.activeTenantId;
    } else if (viewModeValue === 'cas') {
      form.setAttribute('action', this.casburl);
      const str = '&env=';
      srcUrl = this.casburl + str + envCongif.env;
    } else if (viewModeValue === 'cloudemail') {
      form.setAttribute('action', this.cloudemailurl);
      srcUrl = this.cloudemailurl;
    } else if (viewModeValue === 'cloudemailsecurity') {
      form.setAttribute('action', this.cloudemailsecurityurl);
      srcUrl = this.cloudemailsecurityurl;
    } else if (viewModeValue === 'caas') {
      form.setAttribute('action', this.caasurl);
      const str = '&tenant=';
      const str1 = '&tenantName=';
      srcUrl = this.caasurl + str + this.activeTenantId + str1 + this.activeTenantName;
    } else if (viewModeValue === 'SMA') {
      form.setAttribute('action', this.smaurl);
      const str = '&tenant=';
      const str1 = '&tenantName=';
      srcUrl = this.smaurl + str + this.activeTenantId + str1 + this.activeTenantName;
    } else if (viewModeValue === 'NGMGMT') {
      form.setAttribute('action', this.ngmgmturl);
      srcUrl = this.ngmgmturl;
    } else if (viewModeValue === 'cas2.0') {
      form.setAttribute('action', this.cas2url);
      srcUrl = this.cas2url;
    } else if (viewModeValue === 'sasi') {
      form.setAttribute('action', this.saseurl);
      srcUrl = this.saseurl;
    } else if (viewModeValue.toUpperCase() === 'CSE') {
      form.setAttribute('action', this.cseUrl);
      srcUrl = this.cseUrl;
    } else if (viewModeValue.toUpperCase() === 'TSE') {
      form.setAttribute('action', this.tseUrl);
      srcUrl = this.tseUrl;
    } else if (viewModeValue.toUpperCase() === 'TSEMDR') {
      form.setAttribute('action', this.tseMDRUrl);
      srcUrl = this.tseMDRUrl;
    } else if (viewModeValue.toLowerCase() === 'wifiplanner') {
      form.setAttribute('action', this.wifiplannerurl);
      const str = 'tenantid=';
      let qsparam:string = str + this.activeTenantId;
      qsparam = jsEncrypt
        .getEncryptObj_msw()
        .encrypt(qsparam);
      const str1 = '?username=';
      const str2 = '&sessionID=';
      const str3 = '&appName=WIFIPLANNER&spogSrc=';
      const str4 = '&returnUrl=';
      const str5 = '&qsparams=';
      // tslint:disable-next-line:max-line-length
      srcUrl = this.wifiplannerurl + str1 + userId + str2 + sessionId + str3 + spogSrc + str4 + returnUrl + str5 + qsparam;
      window.top.location.href = srcUrl;
      return;
    } else if (viewModeValue === 'cloudwaf') {
      form.setAttribute('action', this.wafurl);
      srcUrl = this.wafurl;
    } else if (viewModeValue === 'wireless') {
      form.setAttribute('action', this.wirelessurl);
      srcUrl = this.wirelessurl;
    } else {
      this.$store.commit('stopLoading');
      return;
    }

    const token = document.createElement('INPUT');
    if (viewModeValue === 'wireless') {
      token.setAttribute('name', 'token');
    } else {
      token.setAttribute('name', 'authtoken');
    }
    token.setAttribute('value', JSON.parse(localStorage.getItem(currentUserKey) as any).token);
    form.appendChild(token);
    if (viewModeValue === 'wireless') {
      const tenantid = document.createElement('INPUT');
      tenantid.setAttribute('name', 'tenantId');
      tenantid.setAttribute('value', this.activeTenantId);
      form.appendChild(tenantid);
      const username = document.createElement('INPUT');
      username.setAttribute('name', 'userName');
      username.setAttribute('value', userId);
      form.appendChild(username);
    }
    if (viewModeValue === 'wireless' || viewModeValue === 'cloudwaf') {
      if (viewModeValue === 'wireless' && await this.getAccessCodeEligibility('ISWNMSAFEENABLED')) {
        const str = '&code=';
        srcUrl = srcUrl + str + this.accessCode;
      } else {
        const str = '&token=';
        srcUrl = srcUrl + str + JSON.parse(localStorage.getItem(currentUserKey) as any).token;
      }
      if (viewModeValue === 'wireless' || viewModeValue === 'cloudwaf') {
        const str1 = '&tenantId=';
        const str2 = '&userName=';
        srcUrl = srcUrl + str1 + this.activeTenantId;
        srcUrl = srcUrl + str2 + userId;
      }
    } else if (viewModeValue === 'NGMGMT' && !this.nsmOldUrlSelected && await this.getAccessCodeEligibility('ISNSMSAFEENABLED')) {
      const str = '&code=';
      srcUrl = srcUrl + str + this.accessCode;
    } else if (viewModeValue === 'cloudemail' && await this.getAccessCodeEligibility('ISHESSAFEENABLED')) {
      const str = '&code=';
      srcUrl = srcUrl + str + this.accessCode;
    } else if (viewModeValue === 'cloudemailsecurity' && await this.getAccessCodeEligibility('ISCESSAFEENABLED')) {
      const str = '&code=';
      srcUrl = srcUrl + str + this.accessCode;
    } else if (viewModeValue === 'SMA' && await this.getAccessCodeEligibility('ISSMASAFEENABLED')) {
      const str = '&code=';
      srcUrl = srcUrl + str + this.accessCode;
    } else if (viewModeValue === 'cas' && await this.getAccessCodeEligibility('ISSHADOWITSAFEENABLED')) {
      const str = '&code=';
      srcUrl = srcUrl + str + this.accessCode;
    } else if (viewModeValue === 'sasi' && await this.getAccessCodeEligibility('ISSASESAFEENABLED')) {
      const str = '&code=';
      srcUrl = srcUrl + str + this.accessCode;
    } else if (viewModeValue === 'CSE' && await this.getAccessCodeEligibility('ISCSESAFEENABLED')) {
      const str = '&code=';
      srcUrl = srcUrl + str + this.accessCode;
    } else if (viewModeValue === 'TSE' && await this.getAccessCodeEligibility('ISTSESAFEENABLED')) {
      const str = '&code=';
      srcUrl = srcUrl + str + this.accessCode;
    } else if (viewModeValue === 'TSEMDR' && await this.getAccessCodeEligibility('ISTSESAFEENABLED')) {
      const str = '&code=';
      srcUrl = srcUrl + str + this.accessCode;
    } else {
      const str1 = '&authtoken=';
      srcUrl = srcUrl + str1 + JSON.parse(localStorage.getItem(currentUserKey) as any).token;
    }
    const frmviewmode = document.createElement('INPUT');
    frmviewmode.setAttribute('name', 'viewMode');
    frmviewmode.setAttribute('value', viewModeValue.toUpperCase());
    form.appendChild(frmviewmode);
    const viewmd = '&viewMode=';
    srcUrl = srcUrl + viewmd + viewModeValue.toUpperCase();

    const spogSrcUrl = document.createElement('INPUT');
    spogSrcUrl.setAttribute('name', 'spogSrc');
    spogSrcUrl.setAttribute('value', spogSrc);
    form.appendChild(spogSrcUrl);
    const spgsrc = '&spogSrc=';
    srcUrl = srcUrl + spgsrc + spogSrc;

    const redirectURL = document.createElement('INPUT');
    redirectURL.setAttribute('name', 'redirectUrl');
    redirectURL.setAttribute('value', returnUrl);
    form.appendChild(redirectURL);

    if (viewModeValue !== 'cloudemail') {
      const redirctstr = '&redirectUrl=';
      srcUrl = srcUrl + redirctstr + returnUrl;
    }
    const caller = document.createElement('INPUT');
    caller.setAttribute('name', 'caller');
    caller.setAttribute('value', 'MSW');
    form.appendChild(caller);

    if (viewModeValue === 'cas') {
      const username = document.createElement('INPUT');
      caller.setAttribute('name', 'userName');
      caller.setAttribute('value', userId);
      form.appendChild(username);

      const tenantid = document.createElement('INPUT');
      caller.setAttribute('name', 'tenantid');
      caller.setAttribute('value', this.activeTenantId);
      form.appendChild(tenantid);
    }

    if (viewModeValue !== 'cas2.0' && viewModeValue !== 'SMA' && viewModeValue !== 'sasi' && viewModeValue !== 'cloudemailsecurity' && viewModeValue.toUpperCase() !== 'CSE') {
      const str = '&caller=MSW&domain=';
      srcUrl = srcUrl + str;
    }
    if (viewModeValue === 'cas') {
      const str = '&userName=';
      const str1 = '&tenantId=';
      srcUrl = srcUrl + str + userId + str1 + this.activeTenantId;
    }
    if (viewModeValue === 'cloudemailsecurity' || viewModeValue === 'sasi' || viewModeValue === 'NGMGMT' || (viewModeValue === 'mgmt' && isSafari)) {
      const srctemp = btoa(srcUrl);
      const str1 = '/redirect-to-application?username=';
      const str2 = '&sessionID=';
      const str3 = '&appName=';
      const str4 = '&tenant=';
      const str5 = '&returnUrl=';
      // tslint:disable-next-line:max-line-length
      srcUrl = envCongif.api_url + str1 + userId + str2 + sessionId + str3 + viewModeValue.toUpperCase() + str4 + this.activeTenantId + str5 + srctemp;
    }
    console.warn(srcUrl);
    if (this.embedView) {
      if (this.nsmNewUrl || viewModeValue === 'sasi' || viewModeValue === 'cloudemailsecurity') {
        window.open(srcUrl, '_blank');
      } else {
        window.top.location.href = srcUrl;
      }
    } else {
      if (viewModeValue === 'wireless' && this.respContent.isWNMPopup && !this.embedView) {
        this.wnmRedirectUrlAfterVdo = srcUrl;
        this.showWNMVdoPopup = true;
        this.$store.commit('stopLoading');
      } else {
        this.wnmRedirectUrlAfterVdo = '';
        window.top.location.href = srcUrl;
      }
    }
    domain.setAttribute('name', 'domain');
    return;
  }
  async getAccessCode(ele : any) {
    let returnFlag = false;
    const req = {
      tenantId : this.activeTenantId.toString(),
      tileName: ele,
    };
    await this.$store.dispatch('SpogHomepageStoreModule/getCscAccessCode', req)
    .then((result : any) => {
      this.$store.commit('stopLoading');
      if (result.operationStatus === 'OK') {
        returnFlag = true;
        this.accessCode =  result.content.accessCode || 'error';
      } else {
        this.accessCode = 'error';
      }
    });
    return returnFlag;
  }

  goToMsw(srcUrl: any, openInNewTab = false) {
    const idx = srcUrl.indexOf('tok');
    const url = srcUrl.substr(0, idx)
    .concat('code=');
    const queryParamIndex = srcUrl.indexOf('sid');
    const queryParamUrl = srcUrl.substr(queryParamIndex);
    // CALL THE API TO GET THE CODE
    const req = {
      tenantId : this.activeTenantId.toString(),
      tileName: 'ISMSWSAFEENABLED',
    };
    this.$store.dispatch('SpogHomepageStoreModule/getCscAccessCode', req)
    .then((result : any) => {
      this.$store.commit('stopLoading');
      const { accessCode } = result.content;
      const finalUrl = url.concat(accessCode)
      .concat(`&${queryParamUrl}`);
      if (['DEV', 'QA'].includes(envCongif.env)) {
        console.warn(`csc finalUrl : ${finalUrl}`);
      }
      if (openInNewTab) {
        window.open(finalUrl, '_blank');
      } else {
        window.top.location.href = finalUrl;
      }
    });
  }

  async getAccessCodeEligibility(code: any) {
    let returnFlag = false;
    const wnmIndex = this.arrTenantOptions.findIndex((ele : any) => ele.tileType === code);
    if (wnmIndex > -1) {
      if (this.arrTenantOptions[wnmIndex].Value === 'YES') {
        returnFlag = await this.getAccessCode(code);
        console.warn(returnFlag);
      }
    }
    return returnFlag;
  }
  // tslint:disable-next-line:no-unused
  trackGAEvents(eventCatgry: string, eventActn: string) {
    // window['ga']('send', 'event', {
    //   eventCategory : eventCatgry,
    //   eventLabel : eventActn,
    //   eventAction : eventActn,
    //   eventValue : 10,
    // });
  }
  resetVueStore() {
    this.$store.commit('startLoading');
    this.$store.dispatch('resetStore');
    this.$store.dispatch('DashBoardStoreModule/resetStore');
    this.$store.dispatch('MswProductsStoreModule/resetStore');
    this.$store.dispatch('DropdownStoreModule/resetStore');
  }
  async logout(mode:string = 'logout') {
    this.workOnEventListener = false;
    if (this.isdemouser) {
      return;
    }
    const req = {
      allAPPS: mode === 'logoutAll' ? 'YES' : 'NO',
    };
    await this.$store.dispatch('logout', req)
    .then((res:any) => {
      if (res.operationStatus === 'OK') {
        this.resetVueStore();
        if (localStorageKeeperService.retrieve('showPendo') !== null) {
          localStorageKeeperService.cleanKey('showPendo');
        }
        localStorage.removeItem(currentUserKey);
        localStorage.removeItem('supportCasesData');
        idb.refreshStore(CSC_STORE_NAME);
        idb.clearData()
        .then(() => {
          let srcUrl = `${envCongif.spog_url}/muir/spog/login?logout=true`;
          if (this.showAppTrayBypClid === 'ACCOUNTSMSW312312') {
            if (mode === 'logoutAll') {
              if (res.idplogoutUrl && res.idplogoutUrl !== '') {
                window.location.replace(res.idplogoutUrl);
                return;
              }
              srcUrl = `${envCongif.accounts_url}/?logout=TRUE`;
            } else if (mode === 'logout') {
              srcUrl = `${envCongif.accounts_url}/dashboard`;
            }
          } else {
            if (res.idplogoutUrl && res.idplogoutUrl !== '') {
              window.location.replace(res.idplogoutUrl);
              return;
            }
            srcUrl = `${envCongif.spog_url}/muir/spog/login?logout=true`;
          }
          window.top.location.href = srcUrl;
        });
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
      }
    })
    .catch((err:any) => {
      console.error(err);
      this.$store.commit('enqueueMessage', {
        infoType: 'failed',
        infoMsg: this.$t('systemMessages.error')
        .toString(),
      });
    });
  }
  toggleSearchBox(val ? : any) {
    if (val) {
      this.showInputBox = true;
    } else {
      this.showInputBox = !this.showInputBox;
    }
    console.warn(this.showInputBox);
    setTimeout(() => {
      const wrapper1 = document.getElementById('searchBox') as HTMLElement;
      console.warn(wrapper1);
      if (wrapper1) {
        wrapper1.children[0]
          .getElementsByTagName('input')[0]
          .focus();
      }
    },         300);
  }
  async highlight(selection : any) {
    this.selection = selection;
    // if (document.getElementById(selection).className.indexOf('inactive') >= 0) {
    if (true) {

    //   document.getElementById(selection).className = document.getElementById(selection).className.replace('inactive', 'active');

      // let home_services = document.getElementById('s-spdg-home-services');
      // let home_meter = document.getElementById('s-spdg-home-meter');

      if (selection === 'cloud') {
        // this.showSSC = false;
        // let meter = document.getElementById('meter');
        // meter.className = meter.className.replace('active', '');
        // meter.className += 'inactive';
        // home_services.style.bottom = '0px'
        // home_meter.style.top = '-100%'
      } else {
        console.warn('got here');
        // this.showSSC = true;
        let senttoken:string = '';
        // let cloud = document.getElementById('cloud');
        // JSON.parse(localStorage.getItem(currentUserKey) as any).displayName
        if (JSON.parse(localStorage.getItem(currentUserKey) as any).roles
        .includes('SPOGSSC') > -1) {
          senttoken = JSON.parse(localStorage.getItem(currentUserKey) as any).token;
        }
        let isRiskMetersSafeEnabled: boolean = false;
        // cloud.className = cloud.className.replace('active', '');
        // cloud.className += ' inactive';
        // home_meter.style.top = '0px'
        // home_services.style.bottom = '-100%';
        isRiskMetersSafeEnabled = this.arrTenantOptions && this.arrTenantOptions.findIndex((arrTenantOption: any) => {
          return arrTenantOption.Value === 'YES' &&
            arrTenantOption.tileType === 'ISRISKMETERSAFEENABLED';
        }) > -1 ? true : false;
        let accessCode: string = '';
        if (isRiskMetersSafeEnabled) {
          accessCode  = await this.getCode('ISRISKMETERSAFEENABLED');
        }
        if (envCongif.env.toLowerCase() === 'dev') {
          if (JSON.parse(localStorage.getItem(currentUserKey) as any).roles
        .includes('RISKMETERBETA') > -1) {
            const str0 = '&code=';
            const str1 = '&token=';
            const str2 = '&tenantid=';
            const str3 = '&username=';
            const str4 = '&tenantname=';
            // tslint:disable-next-line:max-line-length
            this.seccenterurl = this.seccenterdevadminurlinit + str2 + this.activeTenantId + str3 + JSON.parse(localStorage.getItem(currentUserKey) as any).userId + str4 + this.activeTenantEncName;
            if (isRiskMetersSafeEnabled) {
              this.seccenterurl = this.seccenterurl +  str0 + accessCode;
            } else {
              this.seccenterurl = this.seccenterurl +  str1 + senttoken;
            }
          } else {
            const str0 = '&code=';
            const str1 = '&token=';
            const str2 = '&tenantid=';
            const str3 = '&username=';
            const str4 = '&tenantname=';
          // tslint:disable-next-line:max-line-length
            this.seccenterurl = this.seccentterdevurlinit + str2 + this.activeTenantId + str3 + JSON.parse(localStorage.getItem(currentUserKey) as any).userId + str4 + this.activeTenantEncName;
            if (isRiskMetersSafeEnabled) {
              this.seccenterurl = this.seccenterurl +  str0 + accessCode;
            } else {
              this.seccenterurl = this.seccenterurl +  str1 + senttoken;
            }
          }

        } else if (envCongif.env.toLowerCase() === 'simulation') {
          if (JSON.parse(localStorage.getItem(currentUserKey) as any).roles
        .includes('RISKMETERBETA') > -1) {
            const str0 = '&code=';
            const str1 = '&token=';
            const str2 = '&tenantid=';
            const str3 = '&username=';
            const str4 = '&tenantname=';
            // tslint:disable-next-line:max-line-length
            this.seccenterurl = this.seccentersimadminurlinit + str2 + this.activeTenantId + str3 + JSON.parse(localStorage.getItem(currentUserKey) as any).userId + str4 + this.activeTenantEncName;
            if (isRiskMetersSafeEnabled) {
              this.seccenterurl = this.seccenterurl +  str0 + accessCode;
            } else {
              this.seccenterurl = this.seccenterurl +  str1 + senttoken;
            }
          } else {
            const str0 = '&code=';
            const str1 = '&token=';
            const str2 = '&tenantid=';
            const str3 = '&username=';
            const str4 = '&tenantname=';
            // tslint:disable-next-line:max-line-length
            this.seccenterurl = this.seccenttersimurlinit + str2 + this.activeTenantId + str3 + JSON.parse(localStorage.getItem(currentUserKey) as any).userId + str4 + this.activeTenantEncName;
            if (isRiskMetersSafeEnabled) {
              this.seccenterurl = this.seccenterurl +  str0 + accessCode;
            } else {
              this.seccenterurl = this.seccenterurl +  str1 + senttoken;
            }
          }
        } else {
          if (JSON.parse(localStorage.getItem(currentUserKey) as any).roles
        .includes('RISKMETERBETA') > -1) {
            const str0 = '&code=';
            const str1 = '&token=';
            const str2 = '&tenantid=';
            const str3 = '&username=';
            const str4 = '&tenantname=';
            // tslint:disable-next-line:max-line-length
            this.seccenterurl = this.seccenteradminurlinit + str2 + this.activeTenantId + str3 + JSON.parse(localStorage.getItem(currentUserKey) as any).userId + str4 + this.activeTenantEncName;
            if (isRiskMetersSafeEnabled) {
              this.seccenterurl = this.seccenterurl +  str0 + accessCode;
            } else {
              this.seccenterurl = this.seccenterurl +  str1 + senttoken;
            }
          } else {
            const str0 = '&code=';
            const str1 = '&token=';
            const str2 = '&tenantid=';
            const str3 = '&username=';
            const str4 = '&tenantname=';
            // tslint:disable-next-line:max-line-length
            this.seccenterurl = this.seccenterurlinit + str2 + this.activeTenantId + str3 + JSON.parse(localStorage.getItem(currentUserKey) as any).userId + str4 + this.activeTenantEncName;
            if (isRiskMetersSafeEnabled) {
              this.seccenterurl = this.seccenterurl +  str0 + accessCode;
            } else {
              this.seccenterurl = this.seccenterurl +  str1 + senttoken;
            }
          }
        }
        window.open(this.seccenterurl, '_blank');
      }
    }
  }

  async getCode(tileType: string) {
    let code: string  = '';
    const req = {
      tenantId : this.activeTenantId.toString(),
      tileName: tileType || '',
    };
    await this.$store.dispatch('SpogHomepageStoreModule/getCscAccessCode', req)
    .then((result : any) => {
      this.$store.commit('stopLoading');
      if (result.operationStatus === 'OK') {
        code =  result.content.accessCode || 'error';
      } else {
        code = '';
      }
    });
    return code;
  }

  preserveUserInfo(forcedtoken: any, encodedtoken: any  , spoggUser : any) {
    const loginInfo = {
      user: {
        userId: forcedtoken.userName,
        email: forcedtoken.email,
        displayName: forcedtoken.givenName,
        token: encodedtoken,
        sessionId: forcedtoken.sId,
        tfa: forcedtoken.TFA,
        roles: forcedtoken.roles,
        showRegisterPopup: forcedtoken.showRegisterPopup,
        spogUser: spoggUser,
      },
    };
    // window.location.href.indexOf('msw.eng.sonicwall.com') > -1 ? context.commit('loggedInFromMSWToggler') : () => {};
    console.warn(forcedtoken);
    console.warn(loginInfo.user);
    this.$store.commit('updateUserInfo',  JSON.stringify(loginInfo));
    localStorage.setItem(currentUserKey, JSON.stringify(loginInfo.user));
  }
  getImageUrl(tenant :  any) {
    if (tenant.imageUrl.indexOf('http') > -1) {
      return tenant.imageUrl;
    }
    // tslint:disable-next-line:prefer-template
    // return envCongif.spog_url + tenant.imageUrl;
    return envCongif.api_url.substring(0, envCongif.api_url.length - 4) + tenant.imageUrl;
  }
  hoverNewTag(index : any, val : any) {
    this.showToolTip.forEach((ele : any, index : any) => {
      if (ele) {
        this.$set(this.showToolTip, index, false);
      }
    });
    this.$set(this.showToolTip, index, val);
  }
  hoverWarnNewTag(index :any , val : any) {
    // console.warn(index, val);
    this.showWarnToolTip.forEach((ele : any, index : any) => {
      if (ele) {
        this.$set(this.showWarnToolTip, index, false);
      }
    });
    if (val) {
      this.$set(this.showHoverOverMessage, index, false);
    }
    this.$set(this.showWarnToolTip, index, val);
  }
  hoverMouserHover(service : any, index :any , val : any) {
    // console.warn('parent over');
    this.showUnifiedInsightPopup = false;
    if (!service.isEnabled || service.isNoAccess) {
      this.showHoverOverMessage.forEach((ele : any, index : any) => {
        if (ele) {
          this.$set(this.showHoverOverMessage, index, false);
        }
      });
      if (val) {
        if (this.showWarnToolTip[index]) {
        } else {
          this.$set(this.showHoverOverMessage, index, val);
        }
      } else {
        this.$set(this.showHoverOverMessage, index, val);
      }
    }
  }
  getServiceMessage(service : any) {
    if (service.isNoAccess) {
      return this.$t('spog.homepage.servMsg1')
      .toString();
    }
    return this.$t('spog.homepage.servMsg2')
    .toString();
  }
  hoverToolTipTag(index : any , val : any) {
    if (val) {
      this.showToolTip.forEach((ele : any, index : any) => {
        if (ele) {
          this.$set(this.showToolTip, index, false);
        }
      });
    }
    this.$set(this.showToolTip, index, val);
  }
  getShowTag(index : any) {
    console.warn(index);
    return this.showToolTip[index];
    // return false;
  }
  getWarnShowTab(index : any) {
    // console.warn(index);
    return this.showWarnToolTip[index];
  }
  getHoverOverMessage(index : any) {
    // console.warn(index);
    return this.showHoverOverMessage[index];
  }
  nothing() {
    console.warn('prevent');
  }
  redirectToMsw() {
    // console.warn(this.respContent);
    window.open(this.respContent.showmoreURL, '_blank');
  }
  redirectToMswLicenses(service : any) {
    this.getAccessCodeEligibility('ISMSWSAFEURL');
    console.warn(service);
    let srcUrl = '';
    const str1 = `${envCongif.msw_url}/muir/login?code=`;
    const str2 = '&sid=';
    const str3 = '&un=';
    const str4 = '&roles=';
    const str5 = '&dn=';
    const str6 = '&tenantId=';
    const str7 = '&tenantName=';
    const str8 = '&spogUser=';
    const str9 = '&REDIRECTPAGE=';
      // tslint:disable-next-line:prefer-template
    const str10 = `${envCongif.msw_url}/muir/ui/productsgrid?serNo=` + service.renewUrl + '&tab=licenses';
      // tslint:disable-next-line:max-line-length
    srcUrl = str1 + this.accessCode +
    str2 + JSON.parse(localStorage.getItem(currentUserKey) as any).sessionId +
    str3 + JSON.parse(localStorage.getItem(currentUserKey) as any).userId +
    str4 + JSON.parse(localStorage.getItem(currentUserKey) as any).roles +
    str5 + JSON.parse(localStorage.getItem(currentUserKey) as any).displayName +
    str6 + this.activeTenantId +
    str7 + this.activeTenantName  +
    str8 + true +
    str9 + btoa(str10);
    if (this.embedView) {
      window.open(srcUrl, '_blank');
    } else {
      window.top.location.href = srcUrl;
    }
  }
  clickChecked(vdoBanner = false) {
    this.showNsmSliderAfterPopUp && !vdoBanner ? this.showPopUp = true : this.showPopUp = false;
    this.showCheckBoxPopup = false;
    if (this.nonclickableCheck || vdoBanner) {
      const req = {
        highlighterNeeded : 'NO',
        mode : vdoBanner ? 'CSCVIDEOBANNER' : 'NSMINFOBANNER',
      };
      console.warn(req);
      this.$store.dispatch('SpogHomepageStoreModule/postDisableMessage', req)
      .then((result) => {
        if (result.operationStatus === 'OK') {
          if (vdoBanner) {
            this.$store.commit('stopLoading');
            this.showVdoPopUp = false;
          } else {
            this.setNSMItemLists();
            this.$store.dispatch('SpogHomepageStoreModule/getTenantDetail', false)
            .then((response) => {
              this.$store.commit('stopLoading');
              response.content.isNSSMPopup = false;
              this.updateLocalForage(response);
            });
            this.respContent.isNSSMPopup = false;
            if (!this.showNsmSliderAfterPopUp) {
              if (this.serviceSelected[0].serviceName.toUpperCase()
      .indexOf('MANAGEMENT') > -1) {
                this.toggleCurtain(false, true, 'FW MANAGEMENT', this.serviceSelected[0].navigateUrl);
              } else {
                this.toggleCurtain(false, true, this.serviceSelected[0].serviceName, this.serviceSelected[0].navigateUrl);
              }
            }
          }
        }
        console.warn(result);
      });
    } else {
      if (!this.showNsmSliderAfterPopUp && !vdoBanner) {
        this.setNSMItemLists();
        if (this.serviceSelected[0].serviceName.toUpperCase()
    .indexOf('MANAGEMENT') > -1) {
          this.toggleCurtain(false, true, 'FW MANAGEMENT', this.serviceSelected[0].navigateUrl);
        } else {
          this.toggleCurtain(false, true, this.serviceSelected[0].serviceName, this.serviceSelected[0].navigateUrl);
        }
      }
    }
  }
  updateLocalForage(response : any) {
    this.$store.dispatch('SpogHomepageStoreModule/saveTenantList', response)
      .then((result) => {
        console.warn(result);
      });
  }
  toggleSearchBoxPopup() {
    this.showInputBoxPopup = !this.showInputBoxPopup;
  }
  openHelpUrl() {
    window.open(this.capturecloudhelpurl, '_blank');
  }
  getCursorField(val : any) {
    let ret : boolean;
    if (val === 2) {
    // tslint:disable-next-line:max-line-length
      ret = (this.serviceSelected[0].serviceName.toUpperCase() === 'NGMGMT' && this.serviceSelected[0].navigateUrl) || (this.serviceSelected[0].serviceName.toUpperCase()
      .indexOf('MANAGEMENT') > -1 && this.serviceSelected[0].navigateUrl);
    } else {
          // tslint:disable-next-line:max-line-length
      ret = (this.serviceSelected[0].serviceName.toUpperCase() === 'NGMGMT' &&  this.serviceSelected[0].oldNavigateUrl) || (this.serviceSelected[0].serviceName.toUpperCase()
      .indexOf('MANAGEMENT') > -1 && this.serviceSelected[0].oldNavigateUrl);
    }
    return ret;
  }
  navigateNSM(val : any) {
    if (val === 2 && this.serviceSelected[0].serviceName.toUpperCase() === 'NGMGMT' && this.serviceSelected[0].navigateUrl) {
      this.nsmNewUrl = true;
      this.ngmgmturl = this.serviceSelected[0].navigateUrl;
      this.toggleCurtain(false, true, this.serviceSelected[0].serviceName, this.serviceSelected[0].navigateUrl);
      console.warn(this.serviceSelected[0]);
    } else if (val === 1 && this.serviceSelected[0].serviceName.toUpperCase() === 'NGMGMT' && this.serviceSelected[0].oldNavigateUrl) {
      this.nsmOldUrlSelected = true;
      this.ngmgmturl = this.serviceSelected[0].oldNavigateUrl;
      this.toggleCurtain(false, true, this.serviceSelected[0].serviceName, this.serviceSelected[0].oldNavigateUrl);
      console.warn(this.serviceSelected[0]);
    } else if (val === 2 && this.serviceSelected[0].serviceName.toUpperCase()
    .indexOf('MANAGEMENT') > -1  && this.serviceSelected[0].navigateUrl) {
      this.nsmNewUrl = true;
      this.cgmsurl = this.serviceSelected[0].navigateUrl;
      this.cgmsser = this.serviceSelected[0].serialNumber;
      this.toggleCurtain(false, true, 'FW MANAGEMENT', this.serviceSelected[0].navigateUrl);
      console.warn(this.serviceSelected[0]);
    } else if (val === 1 && this.serviceSelected[0].serviceName.toUpperCase()
    .indexOf('MANAGEMENT') > -1 && this.serviceSelected[0].oldNavigateUrl) {
      this.nsmOldUrlSelected = true;
      this.cgmsurl = this.serviceSelected[0].oldNavigateUrl;
      this.cgmsser = this.serviceSelected[0].serialNumber;
      this.toggleCurtain(false, true, 'FW MANAGEMENT', this.serviceSelected[0].oldNavigateUrl);
      console.warn(this.serviceSelected[0]);
    } else if (this.mode === 'tileclick') {
      this.mode = '';
      const message: InfoState = { infoType: 'high', infoMsg: 'Please send correct tenant version.' };
      this.$store.commit('displayMessage', message);
    }
  }
  getImageSize(service : any) {
    if (service.TileNewText && service.TileNewText.length > 0) {
      // tslint:disable-next-line:max-line-length
      if ((service.status && service.status === 'FAILURE')  || (!service.isEnabled && service.avaiableRatio.search('0 of') < 0 && service.avaiableRatio !== '-1' && service.avaiableRatio !== '0' && service.isNoAccess === false)) {
        console.warn('false sent');
        return false;
      }
      return true;
    }
    return true;
  }
  getSlicedTenantName(tenant : any) {
    return tenant.name.toUpperCase();
  }
  openUploadModal(tenant : any) {
    if (this.isreadonlyuser) {
      return;
    }
    this.imageUploadTenantId = tenant.productGroupID;
    this.showImageUpload = true;
    console.warn(tenant);
  }
  inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }
  showLeftTooltip(index : any) {
    return index === 5 || index === 11 || index === 10 || index === 4;
  }
  // unifiedInsightClick() {
  //   if (this.showUnifiedInsightEnabled) {
  //     localStorage.setItem('tenant', this.activeTenantId);
  //     localStorage.setItem('tenantname', this.activeTenantName);
  //     // const redirectUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/workspace/m/feature/unified-insights`;
  //     // window.open(redirectUrl, '_blank');
  //     const uid = JSON.parse(localStorage.getItem(currentUserKey) as any).userId;
  //     // tslint:disable
  //     gtag('set', { 'user_id': uid });
  //     gtag('event', 'service_click', {
  //       'event_category' : 'click',
  //       'event_label' : 'Unified Insight',
  //       'value': 'Unified Insight',
  //     });
  //     // tslint:enable
  //     if (this.embedView) {
  //       const redirectUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/workspace/m/feature/unified-insights`;
  //       window.top.location.href = redirectUrl;
  //     } else {
  //       this.$router.push({ path: '/m/feature/unified-insights' });
  //     }
  //   }
  // }
  clickCheckedForWireless() {
    const req = {
      highlighterNeeded : 'NO',
      mode : 'WNMINFOBANNER',
    };
    console.warn(req);
    this.$store.dispatch('SpogHomepageStoreModule/postDisableMessage', req)
    .then((result) => {
      if (result.operationStatus === 'OK') {
        this.$store.dispatch('SpogHomepageStoreModule/getTenantDetail', false)
        .then((response) => {
          this.$store.commit('stopLoading');
          response.content.isWNMPopup = false;
          this.updateLocalForage(response);
          this.showWNMVdoPopup = false;
        });
        this.respContent.isWNMPopup = false;
        if (this.wnmRedirectUrlAfterVdo === '') {
          this.showFirewallDialog = true;
        } else {
          window.top.location.href = this.wnmRedirectUrlAfterVdo;
        }
      } else {
        this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'failed', infoMsg: result.msgDesc };
        this.$store.commit('enqueueMessage', message);
      }
    });
  }
  getShowUnifiedInsightFlag() {
    if (this.activeTenantId) {
      const ind = this.tenantList.findIndex((ele : any) => ele.productGroupID?.toString()
      ?.toLowerCase() === this.activeTenantId?.toString()
      ?.toLowerCase());
      if (ind > -1) {
        const unifiedDisabledFlag = [false, false, false];
        // tslint:disable-next-line:max-line-length
        unifiedDisabledFlag[0] = this.tenantList[ind].cloudServices.filter((ele : any) => ele.serviceName === 'Capture Client' && ele.isEnabled).length > 0 ? true : false;
        // tslint:disable-next-line:max-line-length
        unifiedDisabledFlag[1]  =  this.tenantList[ind].cloudServices.filter((ele : any) => (ele.serviceName?.toLowerCase()
        .indexOf('management') > -1 || ele.serviceName?.toLowerCase()
        .indexOf('ngmgmt') > -1) && ele.isEnabled).length > 0 ? true : false;
        // tslint:disable-next-line:max-line-length
        unifiedDisabledFlag[2]  = this.tenantList[ind].cloudServices.filter((ele : any) => ele.serviceName?.toLowerCase() === 'wireless' && !(ele.avaiableRatio?.trim()
        .indexOf('0 of') === 0) && !ele?.isNoAccess && ele.isEnabled).length > 0 ? true : false;
        this.showUnifiedInsightEnabled = unifiedDisabledFlag.filter((ele: any) => ele).length > 0;
      } else {
        this.showUnifiedInsightEnabled = false;
      }
    } else {
      this.showUnifiedInsightEnabled = false;
    }
  }
  clickedOutside(event : any) {
    if (this.showTenantDropDown && !event.target.closest('.spog-homepage_drop-down')) {
      this.showTenantDropDown = false;
    }
  }
  navigateToNewTab(links : any) {
    if (links === 'tools') {
      const srcUrl = this.mswUrlCreation(true);
      this.goToMsw(srcUrl, true);
    } else if (links === 'capture') {
      window.open('https://capturelabs.sonicwall.com', '_blank');
    }
  }
  async setIntervalToCheckExpiration() {
    setInterval(() => {
      let expirationTime = 0;
      const currentUser = localStorage.getItem(currentUserKey);
      const token =  currentUser && JSON.parse(currentUser) ? JSON.parse(currentUser).token : '';
      if (token) {
        const decodedToken : any = decode(token);
        expirationTime =  decodedToken.exp;
      }
      console.warn(expirationTime);
      if (expirationTime && this.isIdle && ((expirationTime - Math.floor(+new Date() / 1000)) < 300)) {
        if (this.showExpirationWarning && (expirationTime - Math.floor(+new Date() / 1000)) < 0) {
          this.logout();
          return;
        }
        this.showExpirationWarning = true;
        this.buttons = [
          { key: 'logout', name: 'Log Out', isDefault: true },
          { key: 'session', name: 'Continue Session' },
        ];
        const options: ConfirmOptions = {
          status: 'major',
          title: 'Confirmation',
          message: 'your session is about to expire, you will be logged out in 60 seconds ?',
          buttons: this.buttons,
        };
        confirmService.confirm(options)
        .then((key) => {
          if (key === 'logout') {
            this.showExpirationWarning = false;
            this.logout();
          } else {
            this.showExpirationWarning = false;
            this.$store.dispatch('SpogHomepageStoreModule/getTokenAndUpdateLocalstorage');
          }
        });
      }
    },          30000);
  }

  private viewMSWAppsRender(h: CreateElement): VNode { // tslint:disable-line
    const allApplnList = this.allApplicationList.map((app:any) => {
      return <div class="chooseMswAppsCard" onClick={this.onClickApplications.bind(this, app)}>
        <img height="90" width="180" src={app.imageURL}/>
        <div class="chooseMswAppsCardTitle">
          { app.applicationName }
        </div>
      </div>;
    });
    return (
      <div class="chooseMswApps">
         { allApplnList }
      </div>
    ) as VNode;
  }

  async getApplications() {
    this.$store
      .dispatch('getApplications')
      .then((res: any) => {
        console.warn(res.content);
        this.allApplicationList = res.content.applicationList;
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  /* tslint:disable-next-line */
  onClickApplications(app: any) {
    this.showMSWApps = false;
    switch (app.applicationName) {
      case 'SandBox':
        this.handlerForSandbox(app.applicationName, app.launchUrl);
        break;
      case 'POSTIT':
        this.$store.dispatch('openURLInNextTab', `${envCongif.msw_url}${app.launchUrl.replace('~', '/muir')}`);
        break;
      case 'Capture Security Center':
        this.handlerForSpog(app.applicationName);
        break;
      case 'MySonicWall':
        this.handlerForMSW(app.applicationName);
        break;
      default:
        this.$store.dispatch('openURLInNextTab', app.launchUrl);
    }
  }

  async generateCodeFromToken(tileName: string) {
    let code = '';
    const requestForCodeGeneration: any = {
      tileName,
      tenantId: '',
    };
    await this.$store.dispatch('MswSupportCasesModule/getCSCScodeForWebChat', requestForCodeGeneration)
      .then((response: any) => {
        if (response?.msgCode === 'MSWAPP:GENERATECSCACCESSCODESUCCESS') {
          this.$store.commit('resetToken');
          if (response?.content?.accessCode) {
            console.warn(response.content.accessCode);
            code = response?.content?.accessCode || '';
          }
        }
      })
      .catch((error) => {
        console.error('Cloud Tenants API error', error);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
    console.warn(code);
    return code;
  }

  private async handlerForSandbox(tileName: string, launchUrl: string) {
    const sandboxAccessCode = await this.generateCodeFromToken(tileName);
    this.$store.dispatch('openURLInNextTab', `${launchUrl}?CODE=${sandboxAccessCode}`);
  }

  private async handlerForSpog(tileName: string) {
    const cscAccessCode = await this.generateCodeFromToken(tileName);
    this.$store.dispatch('openURLInNextTab', `${envCongif.spog_url}/muir/spog/login?CODE=${cscAccessCode}`);
  }

  private async handlerForMSW(tileName: string) {
    const mswAccessCode = await this.generateCodeFromToken(tileName);
    this.$store.dispatch('openURLInNextTab', `${envCongif.msw_url}/muir/login?CODE=${mswAccessCode}`);
  }

  async redirectToSP() {
    confirmService.confirm({
      status: 'major',
      message: String(this.$t('sp.spRedirectMsg1')),
      buttons: [
        {
          key: 'cancel',
          name: String(this.$t('accessMgmt.cancel')),
        },
        {
          key: 'ok',
          name: String(this.$t('accessMgmt.confirm')),
          isDefault: true,
        },
      ],
    })
    .then(async (isConfirmed: any) => {
      if (isConfirmed === 'ok') {
        if (this.spSyncpartial) {
          window.location.href = `${envCongif.sp_url}`;
        } else {
          const req: any = {
            tenantId : '',
            tileName: 'Sonic Platform',
          };
          await this.$store.dispatch('SpogHomepageStoreModule/getCscAccessCode', req)
          .then((result : any) => {
            if (result.operationStatus === 'OK') {
              if (result.content.accessCode) {
                const url = `${envCongif.sp_url}/?CODE=${result.content.accessCode}`;
                window.top.location.href = url;
              }
            } else {
              const message: InfoState = { infoType: 'failed', infoMsg: result.msgDesc };
              this.$store.commit('enqueueMessage', message);
            }
          })
          .catch((err:any) => {
            console.error(err);
          })
          .finally(() => {
            this.$store.commit('stopLoading');
          });
        }
      }
    });
  }

  async getLandingAppApi() {
    await this.$store.dispatch('SnbProfileStoreModule/getDefaultLandingPage')
      .then((resp: any) => {
        if (resp.operationStatus === 'OK') {
          if (resp.content && resp.content.SPSync) {
            const isShowSPButton: string = resp.content.SPSync || 'NO';
            if (isShowSPButton && ['YES', 'PARTIAL'].includes(isShowSPButton.toUpperCase())) {
              if (isShowSPButton.toUpperCase() === 'PARTIAL') {
                this.spSyncpartial = true;
              }
              this.showSPRedirectBtn = true;
            } else {
              this.showSPRedirectBtn = false;
            }
          }
        } else {
          const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
          this.$store.commit('enqueueMessage', message);
          this.showSPRedirectBtn = false;
        }
      })
      .catch((err:any) => {
        console.error(err);
        this.showSPRedirectBtn = false;
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }
}
